{
  "A1": "A1",
  "A2": "A2",
  "accents_and_special_characters": "Acentos y caracteres especiales",
  "account": "Account",
  "activity": "Actividad",
  "actor": "Actor {{number}}",
  "actor_2": "Actor 2",
  "actor_name": "Nombre del actor",
  "actor_voice": "Voz del actor",
  "add_alternatives": "Agregar alternativas",
  "add_another_reply": "Añadir otra respuesta",
  "add_courses": "Añadir cursos",
  "add_answer": "Agregar respuesta",
  "add_image": "Añadir imagen",
  "add_image_desc": "¡Añade una imagen a tu ejercicio!",
  "add_link": "Añadir enlace",
  "add_link_desc": "¡Agrega un enlace a tu ejercicio!",
  "all_steps_complete": "Todos los pasos completados",
  "alternative_versions": "Versiones alternativas",
  "archive_recording_error": "Hubo un problema al archivar la grabación",
  "assign": "Asignar",
  "attach_file": "Adjuntar archivo",
  "bot_not_found": "Chatbot no encontrado",
  "bot_not_found_desc": "No hemos encontrado este chatbot. Es posible que se haya eliminado o que sea privado.",
  "categories": "Categorías",
  "chart": "Gráfico",
  "choose_length_of_roleplay": "Elige la duración del escenario",
  "clear": "Borrar",
  "close_pdf": "Cerrar PDF",
  "comma_seperated_domains": "Dominios separados por comas",
  "community": "Comunidad",
  "datetime": "Fecha y hora",
  "days": "días",
  "days_late": "{{count}} días de retraso",
  "discussion": "Debate",
  "download_error": "Hubo un problema al descargar el archivo",
  "editor_mode": "Modo editor",
  "email_notifications": "Notificaciones por correo electrónico",
  "enter_linguistic_goal": "Introduce tu objetivo lingüístico",
  "add_new": "Añadir nuevo",
  "add_phrase": "Añadir frase",
  "add_phrase_desc": "Agrega una frase nueva {{language}} para que la gente aprenda",
  "add_phrases": "Añadir frases",
  "add_phrases_to_enable_exercise": "Agrega frases para activar el ejercicio",
  "add_question": "Añadir pregunta",
  "add_question_desc": "Haz una pregunta de comprensión. La pregunta puede tener múltiples respuestas correctas.",
  "add_review": "Añadir reseña",
  "add_review_desc": "Comparte tus pensamientos a continuación",
  "add_script": "Añadir la secuencia o guion",
  "add_section": "Añadir sección",
  "add_substitution": "Añadir sustitución",
  "add_substitution_desc": "Con las sustituciones, se puede ver que 'qué' se expande a 'qué es', lo que permite un mejor control sobre cómo responder al mensaje del usuario.",
  "add_topic": "Añadir tema",
  "add_topic_desc": "Los temas son agrupaciones lógicas de desencadenantes. Cuando un usuario está en un tema, solo puede hacer coincidir los desencadenantes que pertenecen a ese tema.",
  "add_topic_to_section": "Agregar tema a la sección {{sectionId}}",
  "add_trigger": "Añadir activador",
  "add_trigger_desc": "Un activador es una línea de texto que se utiliza para coincidir con el mensaje del usuario.",
  "add_variable": "Añadir variable",
  "add_variable_desc": "Las variables de chatbot son piezas de información que describen al chatbot. Con las variables de chatbot, podemos escribir respuestas en las que el chatbot puede decirle al usuario algo sobre sí mismo.",
  "add_voice": "Añadir voz",
  "all": "Todo",
  "all_topics_completed": "Todos los temas completados",
  "alternatives": "Alternativas",
  "alternatives_desc": "Una lista de palabras o frases que se pueden reutilizar en el chatbot.",
  "alternatives_name": "Nombre",
  "alternatives_value": "Lista de palabras (separadas por comas)",
  "answer": "Respuesta",
  "new_answer_placeholder": "Escribe tu respuesta aquí",
  "answer_message_100": "Perfecto, gran trabajo",
  "answer_message_90": "Estás cerca, sigue intentándolo",
  "answer_message_95": "¡Casi, casi!",
  "answer_message_wrong": "Eso no está del todo bien",
  "attempt": "Intento",
  "attempt_messages": "Intento de ejercicio",
  "attempt_table": "Intentos",
  "auto_translate": "Traducción automática",
  "auto_translate_phrase": "Traducción automática de la frase",
  "avg_pronunciation_score": "Avg Pronunciation Score",
  "average_pronunciation_score_tooltip": "Average pronunciation score is",
  "B1": "B1",
  "B2": "B2",
  "back": "Volver",
  "back_to_course": "Volver al curso",
  "blog": "Blog",
  "bot": "Chatbot",
  "bot-listen-and-speak": "Chatbot - Escuchar y Hablar",
  "all_modes": "Todos los modos",
  "bot_information": "Información del chatbot",
  "bot_intro_message": "Mensaje de presentación del chatbot",
  "bot_intro_message_helper_text": "Dejar en blanco si quieres que el alumno inicie la conversación.",
  "bot_name": "Nombre del chatbot",
  "bot_reply": "Respuesta del chatbot",
  "bot_settings": "Configuración del chatbot",
  "bot_title": "Título del chatbot",
  "bot_voice": "Voz del chatbot",
  "bots": "Chatbots",
  "bots_not_found_desc": "Crea el primer chatbot hoy",
  "bots_not_found_title": "No se encontraron chatbots",
  "C1": "C1",
  "C2": "C2",
  "cancel": "Cancelar",
  "card_A1": "A1",
  "card_A2": "A2",
  "card_B1": "B1",
  "card_B2": "B2",
  "card_C1": "C1",
  "card_C2": "C2",
  "change_app_colors": "Cambiar los colores de la aplicación",
  "change_language": "Cambiar el idioma",
  "chatbot_exercise_desc": "Chatea con un chatbot para simular una conversación sobre un tema",
  "chatbots": "Robots de Chat",
  "choose_avatar": "Elige Nuala",
  "choose_from_file": "Elige del archivo",
  "classroom_code": "Código de aula",
  "classroom_code_label": "Introduce el código de aula",
  "classroom_code_not_valid": "Código de aula no válido",
  "classroom_created": "Aula creada",
  "classroom_deleted": "Aula eliminada",
  "classroom_information": "Información del aula",
  "classroom_name": "Nombre del aula",
  "classroom_not_found": "Aula no encontrada",
  "classroom_not_found_desc": "Este aula puede haber sido eliminada",
  "classroom_load_error": "No se pudo cargar el aula",
  "classroom_load_error_desc": "Se produjo un error al cargar esta aula. Inténtalo de nuevo.",
  "classroom_settings": "Configuración del aula",
  "classrooms": "Aulas",
  "classrooms_not_found_desc": "Crea tu aula hoy",
  "classrooms_not_found_title": "No se encontraron aulas",
  "collaborators": "Colaboradores",
  "color": "Color",
  "community_templates": "Plantillas de la comunidad",
  "completed": "Completado",
  "completed_icon": "Icono completado",
  "completion": "Terminación",
  "completions": "Terminaciones",
  "confirmation": "Confirmación",
  "contact_form": "Formulario de contacto",
  "continue": "Continuar",
  "continue_exercise": "Continuar ejercicio",
  "continue_learning": "Continuar aprendiendo",
  "continue_teaching": "Continuar enseñando",
  "copied": "Copiado",
  "copy_to_clipboard": "Copiar al portapapeles",
  "correct": "Correcto",
  "correct_answer": "Respuesta correcta",
  "correct_answer_percentage": "Correct Answer Percentage",
  "course": "Curso",
  "course_code": "Código del curso",
  "course_code_label": "Introduce el código del curso",
  "course_code_not_valid": "Código de curso no válido",
  "course_created": "Curso creado",
  "course_deleted": "Curso eliminado",
  "course_information": "Información del curso",
  "course_name": "Nombre del curso",
  "course_not_found": "Curso no encontrado",
  "course_not_found_desc": "Este curso puede haber sido eliminado",
  "course_outline": "Esquema del curso",
  "course_progress": "Progreso del curso",
  "course_settings": "Configuración del curso",
  "courses": "Cursos",
  "courses_not_found_desc": "Crea tu curso hoy",
  "courses_not_found_title": "No se encontraron cursos",
  "create": "Crear",
  "create_bot": "Crear chatbot",
  "create_classroom": "Crear aula",
  "create_course": "Crear curso",
  "create_course_section": "Crear sección del curso",
  "create_course_section_desc": "Depende de ti cómo estructurar el curso. Por ejemplo, puedes dividirlo como 'Principiante, Intermedio, Avanzado' o 'Semana 1, Semana 2, Semana 3'",
  "create_topic": "Crear tema",
  "created_courses": "Cursos creados",
  "creation_visibility": "El contenido público puede usarse como punto de partida para las creaciones de otros educadores.",
  "creator": "Creador",
  "customization": "Personalización",
  "dark_theme": "Tema oscuro",
  "dark_theme_desc": "Apaga las superficies claras de la página y crea una experiencia ideal para la noche.",
  "delete_bot": "Eliminar chatbot",
  "delete_bot_confirmation": "¿Seguro que quieres eliminar este chatbot?",
  "delete_classroom": "Eliminar aula",
  "delete_classroom_confirmation": "¿Seguro que quieres eliminar este aula?",
  "delete_course": "Eliminar curso",
  "delete_course_confirmation": "¿Seguro que quieres eliminar este curso?",
  "delete_phrase": "Eliminar frase",
  "delete_phrase_confirmation": "¿Estás seguro de que deseas eliminar esta frase?",
  "delete_review": "Eliminar comentario",
  "delete_review_confirmation": "¿Seguro que quieres eliminar tu opinión?",
  "delete_roleplay": "Eliminar juego de rol",
  "delete_roleplay_confirmation": "¿Estás seguro de que deseas eliminar este juego de rol?",
  "delete_section": "Eliminar sección",
  "delete_section_confirmation": "¿Estás seguro de que deseas eliminar esta sección?",
  "delete_topic": "Eliminar tema",
  "delete_topic_confirmation": "¿Seguro que quieres eliminar este tema?",
  "description": "Descripción",
  "difficulty": "Dificultad",
  "difficulties": "Dificultades",
  "disable": "Desactivar",
  "disabled": "Desactivado",
  "display": "Pantalla",
  "display_classroom_code": "Display classroom code",
  "download_csv_file": "Descargar",
  "drop_csv_file_or_click_to_upload": "Arrastra el archivo CSV aquí o haz clic para cargar.",
  "edit": "Editar",
  "edit_bot": "Editar Chatbot",
  "edit_discussion": "Editar discusión",
  "edit_roleplay": "Editar juego de rol",
  "email": "Correo electrónico",
  "enable": "Habilitar",
  "enabled": "Habilitado",
  "enrolment_key": "Clave de inscripción",
  "enrolment_key_not_valid": "Clave de inscripción no válida",
  "enter_private_key": "Introduce la clave privada",
  "error_generating_discussion": "Hubo un problema al generar el debate",
  "exercise": "Ejercicio",
  "exercise_complete": "Ejercicio completo",
  "exercise_completed_icon": "{{name}} completado {{counter}} vez",
  "exercise_completion": "Has completado el ejercicio de {{exercise}} '{{id}}'",
  "exercise_in_progress": "Has empezado el ejercicio de {{exercise}} '{{id}}'",
  "exercise_progress_bar": "Exercise progress bar",
  "exercise_info": "Información del ejercicio",
  "exercise_no_longer_available": "Este ejercicio ya no está disponible",
  "exercises": "Ejercicios",
  "exercises_completed": "Ejercicios completados",
  "exercises_completed_icon": "{{name}} completado {{counter}} veces",
  "exit": "Salir",
  "expand": "Expandir",
  "fill_in_contact_form": "Rellena el siguiente formulario",
  "find_bot": "Encontrar un chatbot",
  "find_classroom": "Encontrar un aula",
  "find_course": "Encontrar curso",
  "find_roleplay": "Encontrar juegos de rol",
  "finish": "Acabado",
  "finish_exercise": "Terminar el ejercicio",
  "for_lang": "Yo hablo",
  "formatting_options": "Opciones de formato",
  "from": "De",
  "fullscreen": "Pantalla completa",
  "generate_definitions_info": "Genera definiciones para las frases de esta lista.",
  "generating": "Generando",
  "get_started": "Comenzar",
  "go_back": "Volver",
  "go_back_to_topic": "Volver al tema",
  "go_to": "Go to",
  "go_to_settings": "Ir a ajustes",
  "group_information_form_title": "Cuéntanos sobre tu grupo",
  "group_member_limit": "Límite de miembros del grupo",
  "group_name": "Nombre del grupo",
  "group_picture": "Imagen del grupo",
  "group_subscription_form_title": "Configura la suscripción del grupo",
  "help": "Ayuda",
  "hidden": "Oculto",
  "hide": "Ocultar",
  "hide_bot": "Ocultar chatbot",
  "hide_chatbots_exercise": "Ocultar chatbots",
  "hide_listening_exercise": "Ocultar ejercicio de audición",
  "hide_menu": "Ocultar menú",
  "hide_options": "Ocultar opciones",
  "hide_pronunciation_exercise": "Ocultar ejercicio de pronunciación",
  "hide_roleplay": "Ocultar juego de rol",
  "hide_roleplays_exercise": "Ocultar juegos de rol",
  "hide_section": "Ocultar sección",
  "hide_topic": "Ocultar tema",
  "hide_translation_exercise": "Ocultar ejercicio de traducción",
  "hide_word_bank": "Ocultar banco de palabras",
  "home": "Inicio",
  "how_to_join_find_button": "Busca el botón {{button}} y haz clic en él.",
  "how_to_join_get_ready": "Prepárate para jugar.",
  "how_to_join_intro": "Para unirte a la partida, sigue estos pasos:",
  "how_to_join_open_classroom": "Abre la clase {{classroom}} o escanea su código QR más abajo",
  "how_to_join_sign_in": "Inicia sesión en tu cuenta.",
  "how_to_join_title": "Cómo unirse a la partida",
  "in_game": "En la partida",
  "in_progress": "Continuar jugando",
  "incorrect": "Incorrecto",
  "insert_bold": "Insertar negrita",
  "insert_italic": "Insertar cursiva",
  "insert_link": "Insertar enlace",
  "insert_photo": "Insertar foto",
  "instruction_message": "Instrucciones",
  "join": "Únete",
  "join_classroom": "Unirse al aula",
  "join_code_desc": "Los estudiantes pueden usar el siguiente código para unirse",
  "join_course": "Unirse al curso",
  "join_date": "Fecha de inscripción",
  "joined": "Te has unido",
  "joined_classroom": "Te has unido al aula",
  "joined_course": "Te has unido al curso",
  "language": "Idioma",
  "language_phrase": "{{language}} Frase",
  "language_translation": "{{language}} Traducción",
  "learn": "Aprende",
  "learn_for_speakers_of": "{{learnLang}} para hablantes de {{forLang}}",
  "learn_lang": "Quiero aprender",
  "leave_classroom": "Salir del aula",
  "leave_classroom_confirmation": "¿Estás seguro de que deseas salir del aula?",
  "leave_course": "Salir del curso",
  "leave_course_confirmation": "¿Estás seguro de que quieres abandonar este curso?",
  "left_classroom": "Has salido del aula",
  "left_course": "Has salido del curso",
  "lets_begin": "Vamos a empezar",
  "library": "Biblioteca",
  "link_name": "Nombre del enlace",
  "link_name_helper_text": "Introduce un nombre para mostrar el enlace",
  "link_value": "URL de enlace",
  "link_value_helper_text": "Introduce la URL para el enlace",
  "listen_to_this_phrase": "Escucha esta frase en {{language}}",
  "listener_dialog_desc": "Elige una voz a continuación para escuchar la pronunciación",
  "listening": "Audición",
  "listening_exercise_desc": "¿Comprendes lo que dice?",
  "load_more_events": "Cargar más eventos",
  "loading": "Cargando",
  "loading_topics": "Cargando temas",
  "logout": "Cerrar sesión",
  "manage_course": "Gestionar el curso",
  "members": "Estudiantes",
  "members_not_found": "Sin miembros",
  "members_not_found_desc": "No se encontraron miembros",
  "message": "Mensaje",
  "method": "Método",
  "missing_details": "Faltan detalles",
  "more_definitions": "Más definiciones",
  "more_options": "Más opciones",
  "more_translations": "Más traducciones",
  "my_courses": "Mis cursos",
  "name": "Nombre",
  "new": "Nuevo",
  "next": "Siguiente",
  "next_with_progress": "Siguiente ({current} de {total})",
  "no_activity_found": "No se encontró actividad",
  "no_chatbot_templates": "No hay plantillas disponibles",
  "no_courses_found": "No se encontraron cursos",
  "no_phrases": "Sin frases",
  "no_topics_available": "No hay temas disponibles",
  "not_in_game": "Fuera de la partida",
  "nualang_templates": "Plantillas",
  "nudge_add_family_name_field_desc": "Añade tus apellidos para que tu profesorado pueda identificarte.",
  "nudge_add_family_name_profile_desc": "Añade tus apellidos a tu perfil para que tu profesorado pueda identificarte.",
  "nudge_add_family_name_title": "Añade tus apellidos",
  "on": "el",
  "only_available_on_chrome": "Solo disponible en Chrome",
  "open_image_library": "Abrir biblioteca de imágenes",
  "open_in_google_sheets": "Abrir en Hojas de cálculo de Google",
  "open_search_student_name_filters": "Open search student name filters",
  "optional": "Opcional",
  "or_choose_from_one_of_the_following": "O elige uno de los siguientes",
  "percentage_complete": "Percentage Complete",
  "perfect_click_finish_create_group": "¡Perfecto! Haz clic en Finalizar para crear tu grupo.",
  "phrase": "Frase",
  "phrase_group_game_in_progress_icon": "{{name}} en curso",
  "phrase_lists_error": "Hubo un problema al cargar las listas de frases",
  "phrases": "Frases",
  "player": "jugador",
  "players": "jugadores",
  "plays": "{{number}} reproducciones",
  "please_select_a_textfield": "Selecciona un campo de texto",
  "popular_courses": "Cursos populares",
  "preview": "Vista previa",
  "preview_pdf": "Vista previa del PDF",
  "previous": "Anterior",
  "print": "Imprimir",
  "private": "Privado",
  "problem": "Ha habido un problema",
  "problem_creating": "Ha habido un problema al crear",
  "problem_deleting": "Ha habido un problema al eliminar",
  "problem_getting_reply": "Ha habido un problema al obtener la respuesta",
  "problem_loading": "Ha habido un problema al cargar",
  "problem_sending_contact_form": "Problema al enviar el formulario de contacto",
  "profile": "Perfil",
  "profiles": "Perfiles",
  "progress_icon": "Icono de progreso",
  "pronounce_this_phrase": "Pronuncia esta frase",
  "pronunciation": "Pronunciación",
  "pronunciation_exercise_desc": "Practica la pronunciación con estas frases",
  "public": "Público",
  "question": "Pregunta",
  "new_question_placeholder": "Escribe tu pregunta aquí",
  "questions": "Preguntas",
  "quit": "Abandonar",
  "recommended": "Recomendado",
  "record_message": "Grabar mensaje",
  "record_unsupported": "La grabación no es compatible con este navegador",
  "records": "Registros",
  "redo_action": "Rehacer",
  "refresh": "Actualizar",
  "remove": "Eliminar",
  "remove_bot": "Eliminar chatbot",
  "remove_card": "Remove Card",
  "remove_roleplay": "Eliminar juego de rol",
  "remove_classroom_member": "Remove Classroom Student",
  "remove_classroom_member_confirmation": "Are you sure you want to remove this student from your classroom",
  "remove_member": "Remove Student",
  "member_removed_from_classroom": "Student removed from classroom",
  "reply": "Responder",
  "reply_options": "Opciones de respuesta",
  "reply_options_are_disabled": "Las opciones de respuesta están deshabilitadas",
  "reply_options_desc": "Permite que los estudiantes elijan la respuesta correcta de una lista de opciones",
  "report_views": "Views",
  "required_for_private_classrooms": "Obligatorio para aulas privadas",
  "required_for_private_courses": "Obligatorio para cursos privados",
  "reset": "restablecer",
  "restart_exercise": "Reiniciar ejercicio",
  "result": "Resultado",
  "retry": "Reintentar",
  "return_to_course": "Volver al curso",
  "review_content": "Revisar contenido",
  "review_title": "Revisar título",
  "reviews": "Reseñas",
  "reviews_not_found": "Sin reseñas",
  "reviews_not_found_desc": "No se encontraron reseñas",
  "roleplay": "Juego de rol",
  "roleplay_exercise_desc": "Simular y responder preguntas sobre conversaciones entre dos personas",
  "roleplay_not_found": "Escenario no encontrado",
  "roleplay_not_found_desc": "No hemos encontrado este escenario. Es posible que se haya eliminado o que sea privado.",
  "roleplays_not_found_desc": "Intenta cambiar los parámetros de búsqueda",
  "roleplay_information": "Información de juego de rol",
  "roleplay_name": "Nombre de juego de rol",
  "roleplay_settings": "Configuración de juego de rol",
  "roleplays": "Juegos de rol",
  "save_changes": "Guardar cambios",
  "save_definitions_error": "Hubo un problema al guardar las definiciones",
  "save_progress": "Guardar Progreso",
  "scenarios": "Escenarios",
  "schedule": "Programar",
  "script_not_found": "Guion no encontrado",
  "script_not_found_desc": "No hemos encontrado este guion. Es posible que se haya eliminado o que sea privado.",
  "search_images": "Buscar imágenes",
  "see_more_pronunciations": "Ver más pronunciaciones",
  "send": "Enviar",
  "show_phrase_list": "Mostrar lista de frases",
  "show_progress": "Mostrar progreso",
  "script": "Guion",
  "search": "Buscar",
  "search_for_student": "Buscar Estudiante",
  "section": "Sección",
  "section_name": "Nombre de sección",
  "sections_not_found": "No se encontraron secciones",
  "sections_not_found_desc": "",
  "select_a_template": "Selecciona una plantilla",
  "select_file": "Seleccionar archivo",
  "select_file_desc": "Coloca el archivo aquí o haz clic para buscar en el ordenador",
  "select_files": "Seleccionar archivos",
  "select_the_from_date": "Seleccione la fecha desde",
  "select_the_to_date": "Seleccione Hasta la fecha",
  "settings": "configuración",
  "share": "Compartir",
  "share_via": "Compartir a través de",
  "show_bot": "Mostrar chatbot",
  "show_chatbots_exercise": "Mostrar chatbots",
  "show_listening_exercise": "Mostrar ejercicio de audición",
  "show_menu": "Mostrar menú",
  "show_options": "Mostrar opciones",
  "show_pronunciation_exercise": "Mostrar ejercicio de pronunciación",
  "show_roleplay": "Mostrar juego de rol",
  "show_roleplays_exercise": "Mostrar juegos de rol",
  "show_section": "Mostrar sección",
  "show_topic": "Mostrar tema",
  "show_translation_exercise": "Mostrar ejercicio de traducción",
  "skip": "Saltar",
  "skip_copy_topic": "Saltar",
  "speakers_of": "Hablantes de",
  "start": "Inicio",
  "start_course": "Iniciar curso",
  "stop": "Detener",
  "stop_recording": "Detener grabación",
  "student_instructions": "Instrucciones para el alumno",
  "student_instructions_placeholder": "Instrucciones para el estudiante:\nPuede agregar su mensaje de instrucciones formateadas aquí \n\ne.g. \"Bienvenido al chatbot, puedes comenzar escribiendo hola \"",
  "student_limit": "Límite de estudiantes",
  "subject": "Tema",
  "submit": "Enviar",
  "submitting": "Enviando",
  "subscription": "Suscripción",
  "subscription_period_end": "Fin del periodo de suscripción",
  "subscription_status": "Estado de la suscripción",
  "substitution_desc": "Realiza cambios en el mensaje del usuario antes de comprobar los desencadenantes.",
  "substitution_name": "Texto original",
  "substitution_name_helper_text": "El texto original que puede aparecer en el mensaje del usuario",
  "substitution_value": "Texto de sustitución",
  "substitution_value_helper_text": "No debe contener ningún símbolo especial o puntuación, y también debe estar en minúscula",
  "substitutions": "Sustituciones",
  "table": "Tabla",
  "thank_you_for_submitting": "Gracias por contactarnos, nos comunicaremos contigo lo antes posible. Regresando a la página de inicio",
  "the_default_topic_is_random": "El tema predeterminado es aleatorio",
  "to": "A",
  "toggle_theme": "Alternar tema claro / oscuro",
  "toggle_light": "Toggle light theme",
  "toggle_dark": "Toggle dark theme",
  "topic": "Tema",
  "topic_code": "Código de tema",
  "topic_desc": "Cuando un usuario está en un tema, solo puede hacer coincidir los activadores que pertenecen a ese tema.",
  "topic_image": "Imagen del tema",
  "topic_information": "Información del tema",
  "topic_name": "Nombre del tema",
  "topic_not_found": "Tema no encontrado",
  "topic_not_found_desc": "Este tema puede haber sido eliminado",
  "topics": "Temas",
  "translate": "Traducir",
  "translate_is_disabled": "La traducción está deshabilitada",
  "translate_this_phrase": "Traduce esta frase",
  "translation": "Traducción",
  "translation_exercise_desc": "Pon a prueba tus habilidades lingüísticas traduciendo frases",
  "translations": "Traducciones",
  "trigger_value": "Activar texto",
  "trigger_value_helper_text": "No debe contener ningún símbolo especial o puntuación, y también debe estar en minúscula",
  "triggers": "Activadores",
  "triggers_desc": "Un activador es una línea de texto que se utiliza para coincidir con el mensaje del usuario.",
  "type": "Tipos",
  "unarchive": "Desarchivar",
  "undo_action": "Deshacer",
  "update": "Actualización",
  "update_image": "Actualizar imagen",
  "update_link": "Actualizar enlace",
  "update_phrase": "Actualizar frase",
  "update_phrase_desc": "Hacer cambios a la frase existente",
  "update_picture": "Actualizar imagen",
  "update_question": "Actualizar pregunta",
  "update_question_desc": "Haga una pregunta de comprensión. La pregunta puede tener múltiples respuestas correctas.",
  "update_recording_error": "Hubo un problema al actualizar la grabación",
  "update_review": "Revisión de actualización",
  "update_review_desc": "Descripción de revisión de actualización",
  "update_section": "Actualizar sección",
  "update_section_desc": "Depende de ti cómo estructurar el curso. Las estructuras de ejemplo son 'Principiante, Intermedio, Avanzado' o 'Semana 1, Semana 2, Semana 3'",
  "update_substitution": "Actualizar sustitución",
  "update_topic": "Actualizar tema",
  "update_trigger": "Actualizar activador",
  "update_variable": "Actualizar variable",
  "upgrade": "Mejorar plan",
  "upload_phrases": "Subir frases",
  "upload_phrases_desc": "Crea y carga un archivo csv como el siguiente ejemplo.",
  "upload_phrases_example_phrase_1": "hola",
  "upload_phrases_example_phrase_2": "adiós",
  "upload_phrases_example_phrase_3": "mi nombre es",
  "upload_phrases_example_definition_1": "Una palabra usada para saludar a alguien",
  "upload_phrases_example_definition_2": "Una palabra usada al despedirse de alguien",
  "upload_phrases_example_definition_3": "Una frase usada para decirle a alguien tu nombre",
  "upload_script": "Subir guion",
  "upload_script_desc": "Carga una secuencia de comandos de juegos de rol con un archivo csv utilizando el formato que se muestra a continuación",
  "use_keyboard": "Usar teclado",
  "use_word_bank": "Usar banco de palabras",
  "user_message": "Mensaje de usuario",
  "user_updated": "Usuario actualizado",
  "variable_desc": "Piezas de información que se pueden utilizar en tu chatbot.",
  "variable_name": "Nombre de variable",
  "variable_value": "Valor de variable",
  "variables": "Variables",
  "vars": "Variables",
  "view_activity": "Ver actividad",
  "view_instruction_message": "Ver instrucciones",
  "view_outline": "Ver esquema",
  "view_progress": "Ver progreso",
  "visibility": "Visibilidad",
  "visit_learning_site": "Visitar el Learning Site",
  "voice_speed_disabled": "La velocidad de voz no está disponible para esta voz",
  "weekly_progress": "Progreso semanal",
  "what_do_you_hear": "¿Qué oyes?",
  "answer_method": "Método de respuesta",
  "answers": "Respuestas",
  "attempt_info": "Información de intento",
  "bot_outputs": "Salidas de chatbot",
  "creator_instructions": "Instrucciones del profesor",
  "creator_instructions_placeholder": "Puedes agregar un mensaje de instrucción formateado para un colaborador del curso aquí, por ejemplo: Bienvenido al chatbot, aquí se explica cómo personalizarlo para tus estudiantes ...",
  "date": "Fecha",
  "fri": "Vie",
  "listener": "Oyente",
  "mon": "Lun",
  "new_bots": "Nuevos chatbots",
  "new_courses": "Nuevos cursos",
  "new_roleplays": "Nuevos juegos de rol",
  "no_results_found": "No se han encontrado resultados",
  "option": "Opción",
  "play_again": "Juega de nuevo",
  "role_played": "Papel desempeñado",
  "sat": "sáb",
  "show_word_bank": "Mostrar banco de palabras",
  "skipped": "Omitido",
  "speak": "Hablar",
  "sun": "dom",
  "text": "Texto",
  "thu": "jue",
  "time": "Hora",
  "time_spent": "Tiempo usado",
  "tue": "mar",
  "view_report": "Ver el informe",
  "voice": "Voz",
  "wed": "mie",
  "word_bank": "Banco de palabras",
  "teach": "Enseñar",
  "active_now": "Activo ahora",
  "manage_classroom": "Gestionar el aula",
  "must_question_least_correct_answer": "Debe ser una pregunta y al menos una respuesta correcta.",
  "enter_name_your_voice_clip": "Introduce un nombre para tu clip de voz",
  "my_unnamed_clip": "Mi clip sin nombre",
  "are_you_sure": "¿Estás seguro?",
  "is_already_created_variable_overwrite": "variable creada ya, ¿deseas sobrescribirla?",
  "is_already_created_substitution_overwrite": "sustitución creada ya, ¿deseas sobrescribirla?",
  "is_already_created_alternative_overwrite": "alternativa creada ya, ¿quieres sobrescribirla?",
  "is_already_created_topic_overwrite": "tema creado ya, ¿quieres sobrescribirlo?",
  "bring_your_bot_picture_name": "Dale vida a tu chatbot dándole una imagen y un nombre",
  "perfect_click_finish_create_bot": "Perfecto, haz clic en terminar para crear tu nuevo chatbot",
  "lets_start_with_some_information_about_your_bot": "Comencemos con algo de información sobre tu chatbot",
  "lets_start_some_information_about_classroom": "Comencemos con información sobre tu aula.",
  "the_language_classroom_teach": "El idioma que se enseñará en este aula",
  "the_language_students_classroom_speak": "El idioma que hablan los alumnos de este aula",
  "limit_access_classroom_visibility_private_including_enrolment_key": "Limita el acceso a tu aula configurando la visibilidad en privado e incluyendo una clave de inscripción",
  "add_collaborators": "Agregar colaboradores",
  "perfect_click_finish_create_classroom": "Perfecto, haz clic en finalizar para crear tu nuevo aula",
  "perfect_click_finish_create_course": "Perfecto, haz clic en finalizar para crear tu nuevo curso",
  "lets_start_information_about_course": "Comencemos con información sobre tu curso.",
  "the_language_course_teach": "El idioma que enseñará este curso",
  "the_language_students_course_speak": "El idioma que hablan los alumnos de este curso",
  "limit_access_course_setting_visibility_private_including_enrolment_key": "Limita el acceso a tu curso configurando la visibilidad en privado e incluyendo una clave de inscripción",
  "selected": "Seleccionado",
  "perfect_click_finish_create_roleplay": "Perfecto, haz clic en terminar para crear tu nuevo juego de rol",
  "lets_start_with_information_about_roleplay": "Comencemos con algo de información sobre tu juego de rol.",
  "invite": "Invitación",
  "topic_settings": "Configuración del tema",
  "topic_title": "Título del tema",
  "unanswered_table": "Sin respuesta",
  "create_roleplay": "Crear juego de rol",
  "roleplays_not_found_title": "Juegos de rol no encontrados",
  "play": "Jugar",
  "delete": "Eliminar",
  "delete_picture": "Eliminar Imagen",
  "use_wordbank_if_stuck": "Utiliza el banco de palabras si necesitas ayuda",
  "play_bot_error": "¡Oh no! Se produjo un problema con el chatbot. Vuelve a intentarlo.",
  "bot_editor_preview_error": "Se ha producido un error. Visita https://nualang.com/guides/create-a-bot para obtener una guía sobre cómo crear un chatbot",
  "manage_courses": "Gestionar los cursos",
  "refresh_courses": "Actualizar cursos",
  "customize_appearance_of_course": "Personaliza la apariencia del curso",
  "customize_appearance_of_classroom": "Personaliza la apariencia del aula",
  "customize_appearance_of_topic": "Customize the appearance of the topic",
  "create_duplicate": "Crear duplicado",
  "section_visibility": "Visibilidad de la sección",
  "choose_a_language": "Elige un idioma",
  "play_bot": "Jugar chatbot",
  "lets_find_a_template": "¡Busquemos una plantilla!",
  "search_by_difficulty": "Buscar por dificultad",
  "search_using_keywords": "Buscar usando palabras clave",
  "select_a_nualang_template": "Selecciona una plantilla de Nualang",
  "select_a_nualang_template_desc": "Plantillas creadas por el equipo de Nualang para ayudarte a empezar.",
  "or_select_a_community_template": "O selecciona una plantilla de la comunidad",
  "or_select_a_community_template_desc": "Las plantillas de la comunidad son creadas por profesores de todo el mundo.",
  "dashboard_welcome": "¡Bienvenido, {{name}}!",
  "dashboard_welcome_desc": "Familiarízate con la pantalla principal, aquí hay algunas formas de comenzar.",
  "enter_course_code": "Introduce un código de curso",
  "enter_course_code_desc": "Si tienes un código de curso, introdúcelo aquí.",
  "enter_classroom_code": "Introduce un código de aula",
  "enter_classroom_code_desc": "Si tienes un código de aula, introdúcelo aquí.",
  "search_nualang": "Explorar Nualang",
  "search_nualang_desc": "Existe una comunidad creciente de profesores con ideas afines que desarrollan conversaciones con nuestros Nualas, por lo que siempre hay algo nuevo que aprender.",
  "create_nualang": "Crea desde cero",
  "create_nualang_desc": "Crea conversaciones y lecciones de idiomas.",
  "roleplay_editor_welcome": "Empezando con el Editor de Juego de Rol",
  "roleplay_editor_options": "Selecciona una opción",
  "roleplay_editor_options_desc": "Elige un Nuala para agregar una nueva línea o añade una pregunta de comprensión.",
  "roleplay_editor_share": "Comparte el juego de rol",
  "roleplay_editor_play": "Jugar juego de rol",
  "bot_editor_welcome": "Empezando con el Editor de Chatbot",
  "bot_editor_sidebar": "Barra lateral del editor",
  "bot_editor_sidebar_desc": "La barra lateral es donde podrás realizar cambios en tu chatbot.",
  "bot_editor_flow_chart": "Circulación de chatbot",
  "bot_editor_flow_chart_desc": "La circulación de chatbot muestra una descripción general de su chatbot y ofrece una vista previa de cómo se verá cada mensaje.",
  "bot_editor_share": "Compartir chatbot",
  "bot_editor_play": "Jugar chatbot",
  "play_roleplay": "Juego de rol",
  "delete_script_item": "Eliminar elemento del guion",
  "delete_script_item_confirmation": "¿Estás seguro de que deseas eliminar este elemento del guion?",
  "add_message": "Añadir mensaje",
  "resources": "Recursos",
  "contact": "Contacto",
  "sign_in": "Iniciar sesión",
  "sign_up": "Regístrate",
  "faqs": "Preguntas frecuentes",
  "guides": "Tutoriales",
  "back_to_app": "Volver a la aplicación",
  "notes": "Notas",
  "notes_placeholder": "Introduce notas aquí",
  "get_in_touch": "Ponte en contacto",
  "get_in_touch_desc": "¿Tienes preguntas o comentarios? Envíanos un mensaje",
  "avatar_generator": "Generador de avatares",
  "avatar_generator_desc": "Crea tu propio avatar personal",
  "upload_image": "Subir imagen",
  "upload_image_desc": "Arrastra y suelta la imagen desde tu ordenador",
  "random": "Aleatorio",
  "done": "hecho",
  "file_size_exceeded": "¡Imagen demasiado grande! Sube una imagen más pequeña",
  "image_selection_failed": "No se ha podido cargar esa imagen. Prueba con otra o sube la tuya.",
  "remove_course": "Eliminar curso",
  "courses_joined": "Cursos en los que participas",
  "classroom_courses_not_found_title": "Aún no hay cursos",
  "classroom_courses_not_found_desc": "Este aula aún no tiene cursos.",
  "in_progress_activity": "En progreso",
  "bot_exercise_welcome": "Empezando con el ejercicio de chatbot",
  "bot_exercise_restart": "¡Reinicia el chatbot!",
  "bot_exercise_keyboard_input": "¡Escríbelo!",
  "bot_exercise_keyboard_input_desc": "Usa el teclado para escribir un mensaje. Si necesitas ayuda con caracteres especiales o deseas añadir un emoticono, prueba estos útiles botones.",
  "bot_exercise_voice_input": "¡Dilo!",
  "bot_exercise_voice_input_desc": "Haz clic en el micrófono para usar tu voz y practicar tu pronunciación.",
  "bot_exercise_send_message": "¡Mándalo!",
  "bot_exercise_send_message_desc": "Envía un mensaje al chatbot y comienza la conversación.",
  "bot_exercise_audio_only_mic": "¡Dilo!",
  "bot_exercise_audio_only_mic_desc": "Toca el micrófono para empezar. Después, simplemente habla con naturalidad — Nuala escuchará y responderá automáticamente durante el resto de la conversación.",
  "roleplay_exercise_welcome": "Introducción al juego de rol",
  "roleplay_exercise_read_script": "¡Aprende tu guion!",
  "roleplay_exercise_read_script_desc": "Lee la conversación y escucha cómo se pronuncian las palabras.",
  "roleplay_exercise_select_an_actor": "¡Elige tu rol!",
  "roleplay_exercise_select_an_actor_desc": "Selecciona el papel que te gustaría desempeñar.",
  "roleplay_exercise_start": "¡Actúalo!",
  "roleplay_exercise_start_desc": "Haz clic en Inicio y usa tu teclado o voz para representar el papel que has elegido.",
  "listening_exercise_welcome": "Introducción al ejercicio de comprensión auditiva",
  "listening_exercise_speak": "¡Escucha la frase!",
  "listening_exercise_speak_desc": "Haz clic para escuchar cómo se pronuncia la frase.",
  "listening_exercise_voice_options": "¡Escucha una voz diferente!",
  "listening_exercise_voice_options_desc": "Escucha la frase que dicha en diferentes voces.",
  "listening_exercise_keyboard_input": "Escribe la respuesta",
  "listening_exercise_keyboard_input_desc": "Usa el teclado para escribir la frase que escuchas.",
  "listening_exercise_word_bank": "¿Necesitas ayuda?",
  "listening_exercise_word_bank_desc": "Utiliza el banco de palabras para seleccionar la respuesta correcta.",
  "translation_exercise_welcome": "Introducción al ejercicio de traducción",
  "translation_exercise_speak": "¡Escucha la frase!",
  "translation_exercise_speak_desc": "Haz clic para escuchar cómo se pronuncia la frase.",
  "translation_exercise_read": "¡Lee la frase!",
  "translation_exercise_read_desc": "Lee la frase a traducir.",
  "translation_exercise_keyboard_input": "Escribe la respuesta",
  "translation_exercise_keyboard_input_desc": "Utiliza el teclado para escribir la traducción.",
  "translation_exercise_word_bank": "¿Necesitas ayuda?",
  "translation_exercise_word_bank_desc": "Utiliza el banco de palabras para seleccionar la respuesta correcta.",
  "pronunciation_exercise_welcome": "Empezando con el ejercicio de pronunciación",
  "pronunciation_exercise_speak": "¡Escucha la frase!",
  "pronunciation_exercise_speak_desc": "Haz clic para escuchar cómo se pronuncia la frase.",
  "pronunciation_exercise_read": "¡Lee la frase!",
  "pronunciation_exercise_read_desc": "Lee la frase a pronunciar.",
  "pronunciation_exercise_voice_input": "¡Pronuncia la frase!",
  "pronunciation_exercise_voice_input_desc": "Haz clic en el micrófono para usar tu voz y practicar tu pronunciación.",
  "exercise_share": "¡Comparte con otros!",
  "exercise_mute": "¡Silencia el sonido!",
  "exercise_skip": "Omitir",
  "exercise_skip_desc": "Pasa a la siguiente frase, podrás volver a intentarlo al final.",
  "exercise_restart": "¡Reiniciar!",
  "what_would_you_like_to_do": "¿Qué te gustaría hacer?",
  "i_want_to_learn": "Quiero aprender:",
  "i_want_to_teach": "Quiero enseñar:",
  "add_alternative_version": "Añadir versión alternativa",
  "language_translation_helper_text": "Presiona la tecla Intro para añadir la traducción.",
  "change_roles": "¿Cambiar de rol?",
  "write_your_feedback_here": "Escribe aquí tus comentarios",
  "yes": "Sí",
  "you_are_human_check": "Confirma que eres una persona",
  "you_will_lose_your_progress_on_this_exercise": "Perderás tu progreso en este ejercicio.",
  "confirm": "Confirmar",
  "general": "General",
  "shuffle_phrases": "Mezclar frases",
  "shuffle_phrases_desc": "Mezcla el orden en el que se hacen las preguntas en los ejercicios.",
  "errors": "Errores",
  "missing_translation": "Falta traducción",
  "missing_phrase": "Falta frase",
  "invalid_image_domain": "La URL de la imagen debe ser de un dominio de Nualang aprobado",
  "row": "Fila",
  "no_valid_type": "El tipo debe ser 'actor' o 'pregunta'",
  "no_actor_text": "Sin texto para el actor",
  "no_actor_number": "El actor debe tener un número al final, por ejemplo: actor1, actor2",
  "no_question": "No hay pregunta",
  "no_answers_provided": "No se proporcionaron respuestas",
  "no_correct_answer_provided": "No se proporcionaron respuestas correctas",
  "no_answers": "Sin respuestas",
  "duplicate_topic": "Duplicar tema",
  "normal_mode": "Modo normal",
  "spreadsheet_mode": "Modo hoja de cálculo",
  "image": "Imagen",
  "delete_selected_row": "Eliminar fila seleccionada",
  "crop_image": "Delimitar Imagen",
  "crop": "Ajustar",
  "zoom": "Zoom",
  "rotate": "Girar",
  "hide_preview": "Ocultar vista previa",
  "show_preview": "Mostrar vista previa",
  "try_again": "Vuelve a intentarlo",
  "confidence_score": "El porcentaje de confianza indica la probabilidad de que las palabras individuales se hayan reconocido correctamente.",
  "subscription_plan_teach": "Programa Enseña",
  "subscription_plan_teacher_pro": "Profesor/a PRO",
  "subscription_plan_basic": "Profesor/a Básico",
  "subscription_plan": "Programa de suscripción",
  "subscription_status_trialing": "Prueba gratuita",
  "subscription_status_active": "Activo",
  "subscription_status_canceled": "Cancelado",
  "subscription_status_undefined": "Gratis",
  "status": "Estado",
  "upgrade_plan": "Renovar Programa",
  "manage_plan": "Gestionar Programa",
  "cancel_plan": "Cancelar Programa",
  "your_plan": "Tu Programa",
  "plan_cost": "Coste del Programa",
  "next_billing_date": "Fin del periodo actual",
  "free": "Gratis",
  "payment_method": "Método de pago",
  "pricing_page_title": "Elige tu programa",
  "pricing_page_subtitle": "Programa de precios para profesores, colegios y distritos.",
  "pricing_page_testimonials_title": "¿Qué dicen los profesores?",
  "compare_plans": "Compara los programas",
  "features": "Herramientas",
  "upgrade_submit": "Promover",
  "upgrade_subscription_desc": "Para acceder a esta herramienta necesitas promover tu cuenta. Haz clic en Promover para ir a la página de precios.",
  "upgrade_plan_explanation": "Para acceder a esta herramienta neceitas promover tu cuenta.",
  "upgrade_subscription_student": "Esta herramienta solo está disponible para profesores.",
  "public_visibility_disabled_wayside": "Las clases están gestionadas por Wayside Publishing y deben permanecer privadas.",
  "public_visibility_disabled_loading": "Todavía estamos comprobando tu suscripción. Actualiza la página si esto no cambia.",
  "public_visibility_disabled_trial": "Las clases públicas no están disponibles durante la prueba gratuita. Mejora a un plan de pago para hacer pública esta clase.",
  "creator_not_subscribed": "No puedes unirte a este contenido porque el creador no está suscrito actualmente.",
  "first_name": "Nombre",
  "last_name": "Apellido",
  "role": "Rol",
  "school_name": "Nombre del colegio o institución",
  "school_district": "Distrito del colegio o institución",
  "city": "Ciudad",
  "state": "Estado",
  "send_message": "Envia mensaje",
  "sign_me_up": "¡Inscríbeme!",
  "free_trial": "Prueba GRATUITA",
  "interactive_demo": "Demostración interactiva",
  "news_and_updates": "Noticias y Actualizaciones",
  "teacher": "Profesor/a",
  "principal": "Director/a",
  "tutor": "Tutor/a",
  "parent": "Padre/Madre",
  "student": "Estudiante",
  "other": "Otro",
  "none": "Ninguno",
  "group_subscription_plans": "Programas de Suscripción Grupal",
  "group_plan": "Programa grupal",
  "leave_group": "Salir del grupo",
  "joined_subscription": "Suscrito/a",
  "joined_subscription_desc": "Bienvenido/a la suscripción grupal de {{groupName}}. ¡Ya estás usando Profesor/a PRO!",
  "unable_to_join_subscription": "No puedes unirte a la suscripción",
  "unable_to_join_subscription_desc": "Ha habido un problema para unirte a la suscripción, por favor inténtalo otra vez más tarde.",
  "unable_to_join_subscription_invalid_email_desc": "No puedes unirte a este grupo si no tienes uno de los emails admitidos: {{allowedDomains}}",
  "unable_to_join_subscription_limit_reached_desc": "'{{groupName}}' ha llegado al límite de miembros. Contacta al administrador para aumentar el límite.",
  "moderated_image_dialog": "Nualang detected an image that was inappropriate, unwanted, or offensive and blocked it to provide a safer user experience. Please try a different image.",
  "moderate_title": "Imagen Bloqueada",
  "recommended_courses": "Cursos recomendados",
  "subscription_status_trialing_expired": "Prueba gratuita vencida",
  "no_public_content_created": "No hay contenido público",
  "add_tag": "Presiona la tecla Intro para añadir una etiqueta",
  "add_collaborator_tag": "Presiona la tecla Intro para añadir un colaborador",
  "add_to_classroom": "Añade a las aulas",
  "add_to_classroom_desc": "Añade '{{courseName}}' a {{classroomNames}}.",
  "change_voice_speed": "¡Cambia la velocidad de la voz!",
  "extra_fast": "Superrápido",
  "fast": "Muy rápido",
  "medium": "Velocidad normal",
  "slow": "Más despacio, por favor",
  "extra_slow": "De palabra en palabra",
  "card_ALL": "Todo",
  "join_classroom_to_access": "Únete al aula para acceder",
  "join_course_to_access": "Únete al curso para acceder",
  "confidence": "Confianza",
  "teach_lang": "Quiero enseñar",
  "write_feedback": "Escribe una reseña",
  "allowed_domains": "Dominios del colegio permitidos (opcional)",
  "add_allowed_domains_desc": "Restringe el acceso basado en el dominio del colegio. Por ejemplo 'schooldomain.com'",
  "send_feedback": "Enviar reseña",
  "add_feedback": "Añadir reseña",
  "feedback_content": "Contenido de la reseña",
  "report_problem": "Reportar un problema",
  "report_problem_input_label": "Descripción del problema",
  "update_feedback": "Actualizar reseña",
  "student_completes_exercise": "Cuando un estudiante completa un ejercicio",
  "delete_feedback_confirmation": "¿Estás seguro de que quieres eliminar esta reseña?",
  "delete_feedback": "Eliminar reseña",
  "updates_to_our_terms_of_service": "Actualización de nuestros Términos de Servicio",
  "email_me_when": "Envíame un correo cuando:",
  "new_classroom": "Aula nueva",
  "student_progress": "Progreso del estudiante",
  "view_course": "Ver Curso",
  "view_section": "Ver Sección",
  "classroom_members_not_found_title": "Todavía no hay miembros",
  "classroom_members_not_found_desc": "Este aula no tiene miembros todavía.",
  "open_topic": "Abrir Tema",
  "click_to_speak": "clic para hablar",
  "click_to_stop": "clic para parar",
  "listening_indicator": "Escuchando ...",
  "save_recording_to_report": "Guarda la grabación en el informe",
  "no_voice_recording_saved": "La grabación de voz no se ha guardado",
  "classrooms_not_created": "No se han creado aulas",
  "select_a_classroom": "Selecciona un aula",
  "voice_attempt": "Intento de voz",
  "upload_variables": "Colgar variables",
  "roleplay_games": "Actividades de los juegos de rol",
  "roleplay_games_description": "Elige una de las tarjetas para hacer un juego específico",
  "choose_game_mode": "Elige un modo de juego",
  "story": "Historia",
  "story_description": "Escucha la conversación entre los personajes y responde las preguntas para comprobar tu comprensión.",
  "fill_in_blanks": "Rellena los huecos",
  "fill_in_blanks_description": "¿Puedes identificar correctamente lo que falta?",
  "fill_in_the_blanks": "Rellena los huecos",
  "fill_in_the_blanks_description": "¿Puedes identificar correctamente lo que falta?",
  "act_it_out": "Actúalo",
  "act_it_out_description": "¿Puedes seleccionar la respuesta correcta?",
  "act_it_out_listening": "Actúalo - Audición",
  "act_it_out_listening_description": "Usa tus destrezas auditivas para seleccionar la respuesta correcta.",
  "act_it_out_speaking": "Actúalo - Pronunciación",
  "act_it_out_speaking_description": "Practica tu pronunciación hablando.",
  "act_it_out_listening_speaking": "Actúalo - Audición y Pronunciación",
  "act_it_out_listening_speaking_description": "Practica tu pronunciación hablando.",
  "select_role": "Selecciona tu rol",
  "select_role_description": "Selecciona el rol que te gustaría interpretar.",
  "mute": "Silenciar",
  "unmute": "Desactivar modo silencio",
  "replay": "Reiniciar",
  "restart": "Reiniciar",
  "group_courses": "Cursos de grupo",
  "select": "Seleccionar",
  "classroom_creator_welcome": "Cómo empezar con tu aula",
  "classroom_creator_add_courses": "Añadir cursos",
  "classroom_creator_add_students_email": "Invita a los estudiantes",
  "classroom_creator_track_progress": "Rastrea la actividad de los estudiantes",
  "classroom_creator_track_progress_desc": "Una vez que los estudiantes se han unido al aula, pulsa para ver su progreso en los cursos añadidos.",
  "next_game": "Próximo Juego",
  "forLang_and_learnLang_the_same": "La lengua de aprendizaje y de hablante es la misma. Por lo tanto, el ejercicio de traducción ha sido desactivado",
  "english": "Inglés",
  "french": "Francés",
  "german": "Alemán",
  "irish": "irlandés",
  "italian": "Italiano",
  "portuguese": "Portugués",
  "spanish": "Español",
  "close": "Cerrar",
  "last": "Último",
  "classroom": "Aula",
  "update_avatar": "Update Avatar",
  "update_avatar_desc": "Update your personal avatar",
  "invite_students": "Invite Students",
  "share_student_link_desc": "Share the instructions below to invite students to join.",
  "invite_link_desc": "Please sign in or create an account on Nualang by clicking this invite link:",
  "join_instructions_1": "This will bring you to the ",
  "join_instructions_2": "I created for you, where you'll have to click ‘Join’",
  "enrollment_key_text": "and input the key: ",
  "copy_student_instructions": "Copy student instructions",
  "or_invite_via": "Or invite via",
  "invite_email_subject": "Invitation to join a Nualang",
  "dear_students": "Dear Students",
  "dashboard": "Dashboard",
  "preview_roleplay": "Preview Roleplay",
  "roleplay_preview": "Preview",
  "roleplay_preview_decription": "Preview the full roleplay script",
  "sort": "Sort",
  "sort_by": "Ordenar por",
  "newest": "Más reciente",
  "alphabetical": "Alfabético",
  "recently_changed": "Modificado recientemente",
  "recently_viewed": "Visto recientemente",
  "oldest": "Más antiguo",
  "default": "Predeterminado",
  "clear_filters": "Borrar filtros",
  "member": "Student",
  "stop_speaking": "Stop Speaking",
  "agree_to_terms_and_conditions_1": "I agree to the ",
  "nualang_terms": "Nualang terms",
  "agree_to_terms_and_conditions_2": ", including acceptance of our ",
  "privacy_policy": "Privacy and Data Protection policy",
  "first_classroom_description": "This is a classroom to help students speak {{learnLang}} with confidence.",
  "upload": "Upload",
  "download": "Download",
  "classroom_creator_add_students_email_desc": "Click to explore different ways to invite students to your classroom.",
  "bot_sign_in_message": "You must be signed in to play this chatbot",
  "course_sign_in_to_access": "Sign in to access this course",
  "have_an_account": "Have an account?",
  "provide_a_little_more_information": "Provide a little more information",
  "instructions": "Instructions",
  "close_preview": "Close Preview",
  "check_recognition": "Check speech recognition",
  "checking_recognition": "Checking speech recognition ...",
  "phrase_recognised": "Phrase recognised",
  "phrase_not_recognised": "Phrase not recognised",
  "speech_recognition_info": " Checking the speech recognition allows you to determine whether or not your students will have difficulty pronouncing this phrase in our exercises.",
  "speech_recognition_error_info": "We recognised your phrase as {{recognisedPhrase}}. We recommend that you reword the phrase and/or add an alternative version.",
  "my_library": "My Library",
  "add_own_exercise_message": "Create new {{exerciseName}} using templates created by you",
  "no_exercises_in_library": "There are no {{exerciseName}} created by you.",
  "classroom_invite_feature_disabled_message": "This feature is disabled because your students will be able to join this classroom automatically.",
  "skip_navigation": "Skip Navigation",
  "generate_roleplay": "Generate Roleplay",
  "choose_topic_for_roleplay": "Choose a topic for the roleplay",
  "roleplay_generated": "Roleplay Generated",
  "select_roleplay": "Select Roleplay",
  "chatgpt_roleplay_description": "This is a roleplay about {{topic}}",
  "check_answer": "Comprobar",
  "card": "Tarjeta",
  "banner": "Bandera",
  "load_more": "Load More",
  "bot_input_placeholder": "Usa el teclado para escribir un mensaje",
  "bot_input_mobile_placeholder": "Escribe un mensaje...",
  "audio_only_mode": "Escuchar y Hablar",
  "audio_only_tooltip": "Cambiar al modo de solo audio",
  "switch_to_text": "Cambiar a texto",
  "switch_to_text_tooltip": "Volver al modo de texto",
  "audio_only_title": "Habla con {{botName}}",
  "audio_only_subtitle": "Una conversación totalmente hablada, sin texto. Se recomiendan auriculares.",
  "audio_only_mode_unavailable_fallback_chat": "Este ejercicio requiere el modo Escuchar y hablar, pero no está disponible en este dispositivo; continuará en modo Chat.",
  "microphone_ready": "Micrófono listo",
  "bot_is_speaking": "Hablando...",
  "thinking_indicator": "Pensando...",
  "start_conversation": "Iniciar la conversación",
  "stop_button_label": "Detener",
  "stop_bot_message": "Detener la voz del chatbot",
  "choose_mode_text_option": "Chat",
  "choose_mode_text_option_desc": "Escribe o habla tus respuestas y lee o escucha las respuestas del bot.",
  "bot_mode_in_progress_icon": "{{mode_name}} conversation currently in progress",
  "bot_mode_completed_icon": "{{mode_name}} completed {{counter}} time",
  "bot_modes_completed_icon": "{{mode_name}} completed {{counter}} times",
  "replay_button_label": "Repetir",
  "replay_bot_message": "Repetir el mensaje del chatbot",
  "you": "Tú",
  "ready_when_you_are": "Listo cuando quieras",
  "bot_speaking_banner": "{{botName}} está hablando",
  "listening_to_you": "Escuchándote",
  "bot_thinking_banner": "{{botName}} está pensando",
  "one_moment": "Un momento",
  "listen_first": "Escucha primero",
  "tap_when_done": "Toca cuando termines",
  "conversation_complete": "Conversación completada",
  "exchanges_label": "Intercambios",
  "time_spoken_label": "Tiempo hablado",
  "review_your_turns": "Revisa tus turnos",
  "submit_to_teacher": "Enviar al profesor",
  "great_job": "¡Muy bien!",
  "or": "o",
  "choose_difficulty_of_roleplay": "Choose a difficulty for the roleplay",
  "child": "Child",
  "game_visibility": "Game Visiblity",
  "duplicate_course": "Duplicate Course",
  "amount_must_not_exceed_10": "Amount must not exceed 10",
  "amount_must_be_greater_than_0": "Amount must be greater than 0",
  "voice_pitch": "Voice Pitch",
  "voice_pitch_example": "Hola, mi nombre es {{name}}",
  "voice_pitch_disabled": "Adjusting the pitch is not possible for this voice.",
  "voice_pitch_x_low": "Very Low",
  "voice_pitch_low": "Low",
  "voice_pitch_medium": "Medium",
  "voice_pitch_high": "High",
  "voice_pitch_x_high": "Very High",
  "contact_us": "Contact Us",
  "contact_us_message": "Thank you for using Nualang. Please send your message below and we will get back to you at the earliest.",
  "expected_phrases": "Expected Phrases",
  "expected_phrases_info": "Phrases you expect your students to use during the exercise that you'd like to be recognised correctly when the student speaks. For example, if the exercise was about the weather you might want to recognise the word 'weather' more often than 'whether'",
  "add_expected_phrases": "Add Expected Phrases",
  "phrase_length_exceeded_error": "Phrase should not exceed 100 characters",
  "whats_new": "What's New",
  "wayside_subscription_message": "Your subscription is managed by Wayside Publishing",
  "select_the_correct_answer": "Select the correct answer",
  "pronunciation_score": "Pronunciation score",
  "pronunciation_score_explanation": "The pronunciation score is based on the number of words recognised correctly ({{transcriptCompletenessPercentage}}%) and how clearly they were recognised.",
  "add_course": "Add Course",
  "generate_roleplay_existing_script_confirmation": "Are you sure you want to replace the existing script?",
  "experimental_feature_desc": "New AI Feature - We would love to hear your feedback",
  "generating_roleplay": "Generating Roleplay",
  "updated": "Updated",
  "exercise_completed": "Exercise Completed",
  "exercise_not_completed": "Exercise Not Completed",
  "view_topic": "View Topic",
  "view_roleplay": "View Roleplay",
  "view_bot": "View Chatbot",
  "student_reports_problem": "A student reports a problem during an exercise",
  "problem_reported": "Problem reported",
  "remove_course_confirmation": "Are you sure you want to remove this course?",
  "classroom_member_limit_reached": "Classroom has reached its student limit",
  "upload_pdf": "Upload PDF",
  "remove_pdf": "Remove PDF",
  "classroom_updated": "Classroom Updated",
  "deleted": "Deleted",
  "created": "Created",
  "moderation_warning": "The following categories were detected in your uploaded image(s): ",
  "warning": "Warning",
  "use_anyways": "Use Anyways",
  "view_pdf": "View Story",
  "schedule_discussion": "Schedule discussion",
  "video_chat": "Video Chat",
  "video_chat_member": "Video Chat Member",
  "create_meeting": "Create meeting",
  "group_assignment": "Group assignment",
  "join_group": "Join Group",
  "groups": "Groups",
  "group": "Group",
  "welcome": "Welcome",
  "classroom_creator_welcome_free_trial": "Welcome to your 30 day free trial of Nualang! To get you started, we have setup your first classroom.",
  "delete_pdf": "Delete PDF",
  "delete_pdf_confirmation": "Are you sure you want to delete this PDF?",
  "course_updated": "Course updated",
  "overwrite_phrases": "Overwrite Phrases",
  "roleplay_game_in_progress_icon": "Roleplay game currently in progress",
  "roleplay_game_completed_icon": "Roleplay game has been completed {{counter}} time",
  "roleplay_games_completed_icon": "Roleplay game has been completed {{counter}} times",
  "page": "Page",
  "unknown": "Desconocido",
  "add_a_discussion_topic": "Agregar un Tema de Discusión",
  "add_a_url_for_students_to_discuss": "Agregar un URL para que los Estudiantes Discutan",
  "images_that_students_can_use_as_a_background_during_the_call": "Imágenes que los Estudiantes Pueden Usar como Fondo Durante la Llamada",
  "discussion_images": "Imágenes de Discusión",
  "images_for_students_to_discuss_during_the_call": "Imágenes para que los Estudiantes Discutan Durante la Llamada",
  "recording_time": "Tiempo de Grabación",
  "due_date": "Fecha de Vencimiento",
  "interculturarity": "Interculturalidad",
  "comprehensibility": "Comprensibilidad",
  "function_and_text_type": "Función y Tipo de Texto",
  "vocabulary_in_context": "Vocabulario en Contexto",
  "Drag_and_drop_image_from_your_computer": "Arrastra y Suelta una Imagen desde tu Computadora",
  "record_time_limit": "Límite de Tiempo de Grabación",
  "schedule_discussion_options": "Opciones de Programación de Discusiones",
  "chat_options": "Opciones de Chat",
  "recording_info": "Submission Info",
  "discussion_id": "ID de Discusión",
  "discussion_prompt": "Pregunta de Discusión",
  "attendees": "Asistentes",
  "created_discussions": "Discusiones Creadas",
  "create_groups": "Crear Grupos",
  "select_all": "Seleccionar Todo",
  "remove_group": "Eliminar Grupo",
  "grouped_discussions": "Discusiones Agrupadas",
  "no_recordings_found": "No Se Encontraron Grabaciones",
  "recordings": "Grabaciones",
  "scheduled_meetings": "Reuniones Programadas",
  "no_meetings_scheduled": "No Hay Reuniones Programadas",
  "discussion_info": "Información de la Discusión",
  "invites": "Invitaciones",
  "invited_members": "Miembros Invitados",
  "minute": "Minuto",
  "feedback": "Comentarios",
  "view": "Ver",
  "no_data_found": "No Se Encontraron Datos",
  "no_past_discussions_found": "No Se Encontraron Discusiones Anteriores",
  "no_submissions_found": "No Se Encontraron Envíos",
  "background_images": "Imágenes de Fondo",
  "no_scheduled_discussions_found": "No Se Encontraron Discusiones Programadas",
  "view_more": "Ver Más",
  "past": "Pasado",
  "submissions": "Envíos",
  "add_a_discussion_prompt": "Agregar un Estímulo de Discusión",
  "join_live_game": "Join Live Game",
  "live_game_medals": "Medallas de juego en vivo",
  "live_game_medals_description": "Desbloquea medallas quedando en 1.°, 2.° o 3.° lugar durante un juego en vivo",
  "classroom_has_no_live_game": "Classroom currently has no live game",
  "speech_recognition_error_info_no_phrase": "We did not recognise your phrase. We recommend that you reword the phrase and/or add an alternative version.",
  "no_conversation_available": "No hay conversación disponible",
  "enrolment_key_min_chars": "Enrolment key must be at least 5 characters long",
  "zoom_in": "Zoom In",
  "zoom_out": "Zoom Out",
  "game_created": "Game created",
  "play_live": "Play Live",
  "play_live_desc": "Select the exercise you'd like to play live in the classroom.",
  "live_dialog_description": "Select the exercise you'd like to play live in the classroom.",
  "no_special_characters": "Cannot contain special characters",
  "required": "Required",
  "nuala_performance_rating": "Calificación de Rendimiento de Nuala",
  "using_nuala_performance": "Si utilizas la Calificación de Rendimiento de Nuala, perderás cualquier calificación creada manualmente.",
  "are_you_sure_nuala_performance": "¿Estás seguro de que quieres usar la Calificación de Rendimiento de Nuala?",
  "course_deletion_note": "*Note deleting this course will also delete the {{sectionCount}} section(s) in this course and its contents",
  "classroom_deletion_note": "*Note deleting this classroom will also delete the {{courseCount}} course(s) in this classroom and its contents",
  "topic_deletion_note": "*Note deleting this topic will also delete the {{phraseCount}} phrase(s), {{botCount}} chatbot(s) and {{roleplayCount}} roleplay(s) in this topic and its contents",
  "section_deletion_note": "*Note deleting this section will also delete the {{topicCount}} topic(s) in this section and its contents",
  "confirmDeletionText": "To confirm deletion, type 'delete' into the field below",
  "subscription_status_cancelled": "Cancelled",
  "subscription_status_active expired": "Expired",
  "subscription_status_active_expired": "Expired",
  "leaderboard": "Leaderboard",
  "waiting_message": "Get ready, the game will start soon",
  "play_game": "Play Game",
  "close_game": "Close Game",
  "cancel_game": "Cancel Game",
  "end_game": "End Game",
  "games": "Games",
  "course_no_sections": "This course has no sections",
  "topic_no_phrases": "This topic has no phrases",
  "next_question": "Next question",
  "your_answer": "Your answer",
  "change_answer": "Change answer",
  "final_results": "Results",
  "game_ended": "Game ended",
  "joined_game": "Joined game",
  "equipment_problem_label": "Equipment problem",
  "equipment_problem_example": "e.g. My speaker or microphone is not working",
  "technical_problem_label": "Technical problem",
  "technical_problem_example": "e.g. The app is not working correctly",
  "content_problem_label": "Content problem",
  "content_problem_example": "e.g. I noticed a mistake in the exercise content",
  "end_question_early": "End Question Early",
  "discussion_topic": "Discussion Topic",
  "discussion_link": "Discussion Link",
  "scheduled": "Scheduled",
  "go_back_to_classroom": "Go back to Classroom",
  "discussion_created": "Discusión Creada",
  "discussion_updated": "Discusión actualizada",
  "give_feedback": "Dar Retroalimentación",
  "nualang_live_welcome": "Welcome to Nualang Live!",
  "nualang_live_invite": "Invite Students",
  "nualang_live_invite_desc": "Click here to see how students join the game.",
  "nualang_live_game_members": "Game Members",
  "nualang_live_game_members_desc": "Click here to see who hasn't joined the game yet.",
  "nualang_live_start_game": "Start the game!",
  "nualang_live_settings": "Game Settings",
  "nualang_live_settings_desc": "Click here to see game options",
  "timer_length": "Timer Length",
  "keyboard_and_word_bank": "Keyboard and Word Bank",
  "keyboard_only": "Keyboard Only",
  "word_bank_only": "Word Bank Only",
  "answer_options": "Answer Options",
  "game_settings": "Game Settings",
  "create_feedback": "Create Feedback",
  "first_place": "First Place",
  "second_place": "Second Place",
  "third_place": "Third Place",
  "final_score": "Final Score",
  "no_discussions_found": "No se encontraron discusiones",
  "no_discussions_found_desc": "Todas las discusiones y presentaciones se pueden encontrar aquí",
  "quality_of_interaction": "Calidad de la Interacción",
  "number_of_questions": "Number of Questions",
  "estimated_game_time": "Estimated Game Time",
  "minutes": "Minutes",
  "discuss": "Discutir",
  "open_live_game": "Open Live Game",
  "correct_answers": "Correct Answers",
  "game_has_ended": "This game has ended, please wait for a new Live Game.",
  "game_has_canceled": "This game has been canceled, please wait for a new Live Game.",
  "allow_wordBank": "Allow students to use the word bank in exercises",
  "creator_default": "Creator's default",
  "course_default": "Course default",
  "course_settings_description": "Adjust the learning experience for students of this classroom",
  "change_settings": "Change Settings",
  "choose_topic_from_pdf_for_roleplay": "Choose a topic for the roleplay based on context from the course pdf",
  "use_context_from_course_pdf": "Use context from course pdf",
  "use_context_from_course_pdf_info": "Turn this on to be able to generate a roleplay based on the contents of the course pdf if the  prompt is relevent to the contents in the pdf",
  "feedback_all_info": "Proporciona comentarios a todos los miembros del grupo de discusión. No puedes proporcionar comentarios tanto grupales como individuales a un estudiante.",
  "rubric_info_desc": "View the Analytic Growth Rubric, the criteria being used in our AI feedback.",
  "rubric_info": "Información sobre la rúbrica",
  "listen_to_story": "Listen to the Story",
  "roleplay_no_interactions": "This roleplay has no interactions",
  "number_of_interactions": "Number of Interactions",
  "archive_title_submissions": "Archive Submissions",
  "archive_description_submissions": "Are you sure you want to archive the submissions?",
  "archive_title": "Archive Discussion",
  "archive_description": "Are you sure you want to archive this discussion? Students invites to this discussion will also be removed.",
  "discussion_templates": "Plantillas de Discusión",
  "discussion_templates_desc": "Use una de nuestras plantillas de discusión predefinidas, aquí para ayudarlo a crear contenido para sus estudiantes",
  "find_courses": "Find Courses",
  "create_your_own": "Create Your Own ",
  "community_courses_description": "Find a course from the library for your students",
  "create_your_own_description": "Build a brand new course for your students",
  "empty_live_dialog_description": "Add a course if you'd like to play live in the classroom.",
  "no_classroom_to_join": "Your teacher has not setup their classroom on Nualang yet. Please ask them to do so, then try again.",
  "resume": "Resume",
  "pause": "Pause",
  "discuss_welcome": "Guía de Discusión",
  "discuss_scheduled_discussions": "Discusiones Programadas",
  "discuss_scheduled_discussions_desc": "Aquí es donde encontrarás las discusiones programadas creadas por el profesor. Podrás unirte a estas discusiones y hablar sobre un tema con otros estudiantes de tu grupo.",
  "discuss_refresh_discussions": "Actualizar Discusiones",
  "discuss_refresh_discussions_desc": "Este botón te permitirá actualizar para obtener las últimas discusiones programadas.",
  "discuss_recorded_discussions": "Grabar Discusiones",
  "discuss_recorded_discussions_desc": "Aquí puedes encontrar las discusiones que has grabado y enviado para que el profesor las revise. Una vez que se den los comentarios, podrás verlos.",
  "discuss_grouped_discussions": "Discusiones Agrupadas",
  "discuss_grouped_discussions_desc": "Aquí puedes encontrar todas las discusiones que has creado para tus estudiantes basadas en el nombre del tema. Haz clic en una discusión agrupada para ver qué grupos de estudiantes se crearon.",
  "discuss_submissions": "Envíos de Discusión",
  "discuss_submissions_desc": "Aquí puedes encontrar los envíos de discusión grabados creados por grupos de estudiantes. Puedes ver su grabación, así como la transcripción de las discusiones y dar comentarios individuales o grupales.",
  "refresh_discuss": "Actualizar Discusión",
  "classroom_creator_add_courses_desc": "Choose how you want to add courses to the classroom.",
  "nuala_ai": "Nuala AI",
  "performance_ratings": "Calificaciones de rendimiento",
  "attended": "Asistió",
  "did_not_attend": "No asistió",
  "discussion_attendance": "Asistencia a la discusión",
  "submitted_recordings": "Grabaciones enviadas",
  "invalid_date": "Invalid Date",
  "go_to_profile_settings": "Go to profile settings",
  "not_applicable": "Omit",
  "comprehension": "Comprehension",
  "feedback_text": "Feedback Text",
  "submit_feedback": "Submit Feedback",
  "select_students_to_group": "Select All Students",
  "created_groups": "Created Groups",
  "feedback_info": "Feedback Info",
  "sample_discussion_ideas": "Sample Discussion Ideas",
  "image_library": "Image Library",
  "interculturality": "Interculturality",
  "add_alternative_version_explanation": "Añade una versión alternativa de la frase para marcarla como correcta e.g 'You are welcome' podría ser una alternativa a 'You're welcome'",
  "upload_video": "Subir Video",
  "select_video_desc": "Arrastra y suelta un video desde tu computadora",
  "add_video": "Agregar Video",
  "video_info": "Video del Curso",
  "play_video": "Reproducir Video",
  "delete_video": "Eliminar Video",
  "delete_video_confirmation": "¿Estás seguro de que quieres eliminar este video?",
  "view_video": "Ver Video",
  "video_options": "Opciones de Video",
  "congratulations": "Congratulations!",
  "medal_has_been_added_to_your_profile": "A medal has been added to your profile",
  "pdf_options": "PDF Options",
  "disable_keyboard": "Disable Keyboard",
  "enable_keyboard": "Enable Keyboard",
  "view_story": "View Story",
  "view_question": "View Question",
  "save_library": "Save to Library",
  "minimum_two_phrases": "This exercise requires a minimum of two phrases in the topic.",
  "roleplay_not_valid": "This exercise requires a minimum of one interaction and one question.",
  "move_topic": "Move Topic",
  "move_section": "Move Section",
  "move_roleplay": "Move Roleplay",
  "duplicate_roleplay": "Duplicate Roleplay",
  "leave_game": "Leave Game",
  "leave_game_confirmation": "Are you sure you want to leave this game?",
  "leave": "Leave",
  "explore": "Explore",
  "listen": "Listen",
  "download_template": "Download Template",
  "member_activity": "Student Activity",
  "move_phrase": "Move Phrase",
  "multiple_choice": "Multiple Choice",
  "record": "Record",
  "nualang_live_help": "How to play",
  "nualang_live_help_desc": "Click here to see how to play the game",
  "roleplay-story": "Story",
  "teach_classrooms_desc": "Manage and interact with your students in a dynamic learning environment",
  "teach_classrooms_title": "Engage Your Classroom",
  "teach_courses_desc": "Design and structure your curriculum to provide a complete learning experience",
  "teach_courses_title": "Build comprehensive courses",
  "teach_roleplays_title": "A new kind of Roleplay",
  "teach_roleplays_desc": "Teaching with roleplays allows your students to participate in scripted conversations, providing a dynamic and immersive way to practice their language skills",
  "teach_bots_title": "Creativity with chatbots",
  "teach_bots_desc": "Teaching with chatbots can help your students develop confidence and a natural conversational style that flows seamlessly, similar to real-life conversations",
  "learn_bots_title": "Creativity With Chatbots",
  "learn_bots_desc": "Learning with chatbots can help you develop a natural and engaging conversational style that flows seamlessly, just like a real conversation",
  "learn_roleplays_title": "A new kind of Roleplay",
  "learn_roleplays_desc": "Learning with roleplays allows you to participate in scripted conversations, providing a dynamic and immersive way to practice language skills",
  "learn_classrooms_desc": "Join classrooms where you can interact with your peers and teachers in a dynamic learning environment",
  "learn_classrooms_title": "Interactive Learning Spaces",
  "learn_courses_desc": "Enroll in courses designed to give you a complete learning experience with structured lessons and activities",
  "learn_courses_title": "Comprehensive learning paths",
  "video_included": "Video",
  "story_included": "Story",
  "answer_helper_text": "Press enter / return key to add answer.",
  "move_answer": "Move Answer",
  "remove_answer": "Remove Answer",
  "remove_question": "Eliminar pregunta",
  "supported_file_types": "Supported file types: mp4, mov",
  "exercise_description": "Listen to this phrase",
  "translate_description": "Translate the phrase as quick as you can for the most points!",
  "result_description": "See where you place against everyone else!",
  "listening_description": "Choose an answer as quick as you can for the most points!",
  "roleplay_intro": "Listen to the conversation between the two characters!",
  "topic_no_roleplays": "This topic has no roleplays.",
  "case_sensitive": "This was marked for case sensitivity",
  "required_field": "Fields marked with * are required",
  "close_drawer": "Close Drawer",
  "generate_question": "Generate Question",
  "generating_question": "Generating Question",
  "experimental_feature_desc_answer": "The 'Generate Question' button is a New AI Feature - We would love to hear your feedback",
  "question_type": "Question Type",
  "multiple_choice_factual": "Multiple Choice - Factual",
  "multiple_choice_inference": "Multiple Choice - Inference",
  "vocabulary": "Vocabulary",
  "true_false": "True/False",
  "insert_emoji": "Insert Emoji",
  "moderation_reason": "Image was blocked for containing: {{moderationReason}}",
  "move_bot": "Move Chatbot",
  "duplicate_bot": "Duplicate Chatbot",
  "incomplete_translation": "There is still more to this sentence!",
  "discuss_description": "Discuss is your platform for live, interactive conversations. Create engaging discussions based on your prompts or choose from suggested topics. Watch as your students collaborate and share ideas in real-time.",
  "enable_discuss": "Enable Discuss in Settings",
  "experimental_feature_desc_phrases": "The 'Generate Phrases' button is a New AI Feature - We would love to hear your feedback",
  "choose_topic_for_phrases": "What would you like the phrases to be about?",
  "how_many_phrases": "Number of Phrases: {{phraseAmount}}",
  "generate_phrases": "Generate Phrases",
  "generating_phrases": "Generating Phrases",
  "duplicate_answer_desc": "A question cannot have duplicate answers",
  "question_language": "Choose a language for the questions and answers",
  "generate_questions": "Generate Questions",
  "enable_gen_questions": "Enable this to generate comprehension questions related to the roleplay.",
  "use_topic_phrases": "Use Topic Phrases",
  "enable_phrase_context": "Enable this to use the phrases from your Topic as context in generating the roleplay.",
  "add_phrase_context": "Please add phrases to your topic to enable this feature.",
  "enter_phrase_with_alternatives": "Enter a phrase with alternatives",
  "sentences": "Sentences",
  "words": "Words",
  "phrase_type": "Phrase Type",
  "archive_classroom": "Archive Classroom",
  "archive_classroom_confirmation": "Are you sure you want to archive this classroom?",
  "unarchive_classroom": "Unarchive Classroom",
  "unarchive_classroom_confirmation": "Are you sure you want to unarchive this classroom?",
  "confirmArchiveText": "To confirm archiving, type 'archive' into the field below",
  "confirmUnarchiveText": "To confirm unarchiving, type 'unarchive' into the field below",
  "generate_bot": "Generate Chatbot",
  "generating_bot": "Generating Chatbot",
  "choose_topic_for_bot": "What would you like this chatbot to be about?",
  "use_context_from_topic_phrases": "Use topic phrases",
  "generate_bot_existing_script_confirmation": "Are you sure you want to replace the existing script?",
  "voice_speed": "Voice Speed",
  "phrase_to_speak": "Phrase to Speak",
  "voice_speed_extra_slow": "Extra Slow",
  "voice_speed_slow": "Slow",
  "voice_speed_medium": "Medium",
  "voice_speed_fast": "Fast",
  "voice_speed_extra_fast": "Extra Fast",
  "play_audio": "Play Audio",
  "generate_audio": "Generate Audio",
  "topic_goal": "Communicative goal",
  "topic_goal_info_text": "What do you want the learner to be able to do at the end of this lesson?",
  "archived_classrooms_title": "No Archived Classrooms",
  "archived_classrooms_desc": "When you're finished with a classroom, you can archive it. This will archive the classroom for all students and collaborators.",
  "bot_created": "Chatbot Created",
  "bot_deleted": "Chatbot Deleted",
  "ukrainian": "Ucranio",
  "arabic": "Arabic",
  "chinese_simplified": "Chinese Simplified",
  "chinese_traditional": "Chinese Traditional",
  "czech": "Czech",
  "danish": "Danish",
  "dutch": "Dutch",
  "filipino": "Filipino",
  "greek": "Greek",
  "hindi": "Hindi",
  "hungarian": "Hungarian",
  "indonesian": "Indonesian",
  "japanese": "Japanese",
  "korean": "Korean",
  "malay": "Malay",
  "polish": "Polish",
  "punjabi": "Punjabi",
  "romanian": "Romanian",
  "swahili": "Swahili",
  "thai": "Thai",
  "turkish": "Turkish",
  "vietnamese": "Vietnamese",
  "speak_disabled": "Speak disabled",
  "move_message": "Move Message",
  "move_question": "Move Question",
  "topic_goal_placeholder": "e.g I can ask and answer questions about my identity.",
  "download_csv_template": "Download CSV Template",
  "upload_csv": "Upload CSV",
  "remove_csv": "Remove CSV",
  "single_phrase": "Single Phrase",
  "list_of_phrases": "List of Phrases",
  "text_studio": "Text-to-Speech Studio",
  "text_studio_description": "The Nualas are here to help you turn text into speech, select a language and choose from our selection of voices to bring your text to life.",
  "no_phrases_yet": "No phrases yet...",
  "access_denied_domain_unverified": "Access Denied: Domain Unverified",
  "file_name": "File Name",
  "download_audio": "Download Audio",
  "no_answer": "No Answer",
  "left_group": "Left Group",
  "view_feedback": "View Feedback",
  "no_feedback": "You have not given this student feedback yet",
  "app_search_placeholder": "Search community content",
  "delete_phrases": "Delete Phrases",
  "delete_phrases_confirmation": "Are you sure you want to delete the chosen phrases?",
  "share_audio": "Please uncheck this box if you do not want to share your audio with Nualang. Sharing the audio will help us diagnose the issue.",
  "edit_phrase": "Edit phrase",
  "share_screenshot": "Please check this box if you would like to share your screenshot with Nualang. Sharing the screenshot will help us diagnose the issue.",
  "screenshot_captured": "Screenshot captured:",
  "classroom_creator_play_live_game": "Play Nualang LIVE",
  "classroom_creator_play_live_game_desc": "Nualang LIVE offers customisable games that create a dynamic and engaging environment for students, allowing them to test their skills and compete against each other to win coveted Nuala medals.",
  "content_tags": "Add Tags",
  "enter_info_tags": "Enter a comma separated list of tags below.",
  "enter_collaborator_email": "Enter a comma or space separated list of email addresses below. Collaborators can manage courses, students, and classroom settings.",
  "enter_domains_info": "Enter a comma or space separated list of school domains below.",
  "search_error": "Se produjo un error durante la búsqueda, inténtelo de nuevo",
  "create_feedback_error": "Se produjo un error al crear la retroalimentación, inténtelo de nuevo",
  "get_recs_error": "Se produjo un error al obtener las grabaciones",
  "get_image_error": "Se produjo un error al obtener las imágenes",
  "update_discussion_error": "Se produjo un error al actualizar la discusión, inténtelo de nuevo",
  "invite_users_error": "Se produjo un error al invitar a los usuarios, inténtelo de nuevo",
  "create_image_error": "Se produjo un error al subir la imagen, inténtelo de nuevo",
  "grade_conversation_error": "Se produjo un error al calificar la conversación, inténtelo de nuevo",
  "get_transcript_error": "Se produjo un error al obtener la transcripción, inténtelo de nuevo",
  "get_subs_error": "Se produjo un error al obtener las entregas, inténtelo de nuevo",
  "delete_picture_confirmation": "Are you sure you want to delete this picture?",
  "inappropriate_language_detected": "Inapproriate Language Detected",
  "schedule_discussion_error": "Se produjo un error al programar la discusión, inténtelo de nuevo",
  "heritage_speaker": "Read/Write",
  "unmark_as_heritage_speaker": "Disable Read/Write Mode",
  "mark_as_heritage_speaker": "Enable Read/Write Mode",
  "heritage_speaker_desc": "Focuses on reading and writing by disabling listening and speaking where appropriate. Designed with heritage learners in mind.",
  "heritage_speaker_point_1": "The word bank will be disabled",
  "heritage_speaker_point_2": "Listening and pronunciation will be disabled where appropriate.",
  "freely_changed": "This can be freely changed at any time.",
  "generate_transcript": "Generate Transcript",
  "suggested_images": "Suggested Images",
  "mark_as_challenge_student": "Enable Challenge Mode",
  "unmark_as_challenge_student": "Disable Challenge Mode",
  "mark_as_challenge_bot": "Mark as Challenge Mode",
  "unmark_as_challenge_bot": "Unmark as Challenge Mode",
  "challenge_student": "Challenge Mode",
  "challenge_student_desc": "Unlocks chatbots that prompt extended responses and formal, academic language. Designed with heritage learners in mind.",
  "challenge_bot": "Challenge Mode",
  "challenge_bot_desc": "This chatbot is visible only to students with Challenge Mode enabled in the Students tab. Designed with heritage learners in mind, it provides formal, academic prompts.",
  "rewatch_tutorial": "Rewatch Tutorial",
  "heritage_speaker_progress": "Students marked as 'Read/Write' will have their learning experience adjusted to focus more on reading and writing.",
  "auto_generate_phrase_translation": "Generate Translations",
  "word_near_correct": "This word is correct, but it is in the wrong position",
  "partially_correct": "Partially Correct",
  "tag_info": "Tags help organize and categorize content, making it easier to find and group related materials. Use tags to improve the discoverability of your content and streamline your workflow.",
  "assignments": "Assignments",
  "assign_exercises": "Assign Exercises",
  "assign_exercises_desc": "Select activities from your curated library of content and assign them to your students with just a few clicks. Watch as they engage with exercises designed to reinforce learning, practice skills, and deepen understanding.",
  "assign_discuss": "Assign Discuss",
  "assign_discuss_desc": "Discuss is your platform for live, interactive conversations. Create engaging discussions based on your prompts or choose from suggested topics. Watch as your students collaborate and share ideas in real-time.",
  "archive_discussions": "Archived Discussions",
  "archive_submissions": "Archived submissions",
  "assignment": "Assignment",
  "create_assignment": "Create Assignment",
  "no_assignments": "No Assignments",
  "assignments_description": "Assignments are a great way to engage your students with interactive content. Create assignments to reinforce learning, practice skills, and deepen understanding.",
  "no_assignments_desc": "There are no assignments in this classroom yet.",
  "select_classroom": "Select Classroom",
  "assignment_title": "Assignment Title",
  "assignment_description": "Assignment Description",
  "select_members": "Select Students",
  "schedule_assignment": "Schedule Assignment",
  "assign_date": "Available From",
  "add_exercise": "Add Exercise",
  "add_exercises": "Add Exercises",
  "assign_exercises_description": "Select exercises from your library to assign to your students",
  "due_in": "Due in",
  "due_tomorrow": "Due Tomorrow",
  "student_edited_transcript": "El estudiante editó manualmente esta transcripción después de la grabación.",
  "member_updated": "Student updated",
  "delete_assignment": "Delete Assignment",
  "delete_assignment_confirmation": "Are you sure you want to delete this assignment?",
  "assignment_deleted": "Assignment deleted",
  "assignment_created": "Assignment created",
  "assignees_created": "Assignees created",
  "classroom_creator_subscription_expired": "The creator's subscription has expired.",
  "return_to_classrooms": "Return to Classrooms",
  "creator_not_subscribed_upgrade_title": "Subscription Expired",
  "creator_not_subscribed_upgrade": "Your subscription has expired. Please upgrade plan in order to continue the following features:",
  "creator_not_subscribed_upgrade_description": "Student access to classroom activities.",
  "creator_not_subscribed_upgrade_description2": "Ability to create Nualang LIVE games",
  "creator_not_subscribed_upgrade_description3": "Student ability to join classroom.",
  "due_today": "Due Today",
  "update_assignment": "Update Assignment",
  "refresh_assignments": "Refresh Assignments",
  "report_type": "Type",
  "go_back_to_assignments": "Go back to Assignments",
  "available_today": "Available Today",
  "available_tomorrow": "Available Tomorrow",
  "available_in": "Available in",
  "not_assigned": "Not Assigned",
  "assigned": "Assigned",
  "view_assignment": "View Assignment",
  "no_assignments_description": "There are currenly no assignments created.",
  "no_shared_courses": "No hay cursos compartidos entre las aulas seleccionadas.",
  "view_submissions": "View Submissions",
  "archive": "Archive",
  "discussions": "Discussions",
  "generated_phrases": "Are you sure you want to add the following generated phrases to the list? These phrases will be appended and will not replace any existing phrases.",
  "everyone": "Everyone",
  "duplicate_course_confirmation": "This will make a copy of the course that you can edit. You won't get updates or changes from the original course.",
  "duplication": "Allow others to duplicate this course.",
  "invalid_email_format": "Invalid email format",
  "email_domain_mismatch_error": "Email must be from your domain ({{domain}}).",
  "generic_email_domain_error": "Generic email domain error",
  "duplicate_disabled_tooltip": "This course has been disabled for duplication by the creator.",
  "collaborators_only": "Collaborators",
  "hide_course": "Hide Course",
  "show_course": "Show Course",
  "default_assignment_title": "New Classroom Assignment",
  "default_assignment_instructions": "Please complete the tasks below before the due date.",
  "due": "Due",
  "hide_from_students": "Hide from Students",
  "show_to_students": "Show to Students",
  "hello": "Hola",
  "dynamic_response": "Dynamic Responses",
  "dynamic_response_desc": "Allow Chatbots in this Classroom to generate customized replies based on student input, powered by AI.",
  "assign_to": "Assign To",
  "all_students": "All Students",
  "ai_chatbot_message_info": "This chatbot message is generated using AI.",
  "ai_chatbot_message_generating_info": "This chatbot message is being generated using AI.",
  "language_correction": "Corrección lingüística",
  "correction_original": "Original",
  "correction_suggested": "Sugerencia",
  "language_corrections_to_review": "Correcciones lingüísticas para repasar",
  "dynamic_responses_info": "Enabling this feature allows the Chatbots to use AI to generate personalized responses based on what students say. While this can support more engaging learning, responses are automatically generated and may vary. All AI use follows clear, trusted standards to ensure safe, responsible, and accountable learning.",
  "paste_your_csv_data": "Paste your CSV data here",
  "user_level_settings": "Configuración a nivel de usuario",
  "chatbot_dynamic_responses": "Chatbot - Respuestas dinámicas",
  "chatbot_dynamic_responses_desc": "Si la respuesta dinámica está activada, el Chatbot escuchará y se adaptará activamente, pidiendo más detalles, una redacción más clara o respuestas realistas, en lugar de simplemente pasar a la siguiente instrucción predefinida.",
  "chatbot_now_ai": "Nualang Chatbot: Now with Real-Time Feedback",
  "chatbot_now_ai_desc": "More speaking support. Same structure. No extra work. Students now get helpful, AI-enhanced feedback as they chat!",
  "chatbot_now_ai_revert_settings": "You can limit AI anytime in your ",
  "prefer_original_version": "Prefer the original version?",
  "chatbot_now_ai_benefit": "It’s like giving every student a conversation coach built right into the activity—with zero extra prep or grading.",
  "ai_learn_more": "Want to learn more? Read our approach to AI safety and trust.",
  "ai_settings_desc": "Choose which AI features are available in this classroom.",
  "limit_ai": "AI in this classroom",
  "limit_ai_desc": "Allow the AI features below in this classroom or disable them entirely.",
  "limit_ai_info": "Disabling AI in this classroom turns off each AI feature below at once: Chatbot dynamic responses and AI-generated feedback on Discuss recordings. Teachers can still write and submit their own feedback. All AI use follows clear, trusted standards to ensure safe, responsible, and accountable learning.",
  "limit_ai_course_desc": "Turn chatbot dynamic responses off for this course only. The classroom setting applies unless you change it here.",
  "chatbot_ai": "Chatbot - Dynamic Responses",
  "chatbot_ai_desc": "Allow AI to generate feedback and responses to students or disable to use scripted replies.",
  "discuss_ai": "Discuss - AI feedback",
  "discuss_ai_desc": "Allow AI to generate draft feedback on student submissions or disable to require teacher created feedback only.",
  "ai_allowed": "Enabled",
  "ai_limited": "Disabled",
  "ai_limited_classroom_notice": "AI is disabled in this classroom, the features below are unavailable.",
  "ai_locked_notice": "AI is limited for your whole organization, so it cannot be changed here. Contact your Nualang administrator if this needs to change.",
  "ai_partly_locked_notice": "Some AI features are limited for your whole organization, so they cannot be changed here. Contact your Nualang administrator if this needs to change.",
  "ai_overview_desc": "AI settings for every classroom you teach, including ones you co-teach. Changes apply to the classroom straight away.",
  "ai_overview_empty": "You don't teach any classrooms yet.",
  "ai_overview_load_failed": "Your classrooms could not be loaded. Please try again.",
  "ai_overview_save_failed": "This change could not be saved",
  "ai_overview_apply_all": "Apply to all",
  "ai_overview_enable_all": "Enable for all classrooms",
  "ai_overview_disable_all": "Disable for all classrooms",
  "ai_overview_apply_all_count": "Classrooms that will change",
  "ai_overview_apply_all_skips": "Archived classrooms, and settings fixed by your organization, are not changed.",
  "ai_overview_apply_all_saved": "Classrooms updated",
  "ai_overview_apply_all_failed": "These classrooms could not be updated",
  "ai_overview_course_overrides": "Courses with the chatbot disabled",
  "ai_overview_open_classroom": "Classroom settings",
  "ai_overview_no_active": "All your classrooms are archived.",
  "ai_course_overrides_notice": "Allowed for this classroom, but disabled for these courses",
  "ai_per_course_hint": "You can also limit chatbot dynamic responses for individual courses in Course settings below.",
  "ai_limited_feedback_blocked": "AI is limited for this classroom, so AI feedback cannot be generated.",
  "ai_settings": "AI Settings",
  "student_sent_inappropriate_messages": "La transcripción a continuación requiere su revisión.",
  "challenge_mode": "Challenge Mode",
  "student_misuse_reported": "Student Misuse Reported",
  "student_acts_inappropriately": "Un estudiante actúa de manera inapropiada durante un ejercicio con el Chatbot",
  "ai_chatbot_error_response": "Disculpa, cometí un error en mi respuesta. ¡Inténtalo de nuevo!",
  "no_members_tooltip": "Cannot perform this action because there are no students or courses in this classroom.",
  "overdue": "Overdue",
  "due_next": "Due Next",
  "active": "Active",
  "archived": "Archived",
  "past_due": "Past Due",
  "available_from": "Available from",
  "roleplay-fill-in-the-blanks": "Scenario fill in the blanks",
  "roleplay-act-it-out": "Scenario act it out",
  "roleplay-act-it-out-listening": "Scenario act it out listening",
  "roleplay-act-it-out-speaking": "Scenario act it out speaking",
  "roleplay-act-it-out-listening-speaking": "Scenario act it out listening and speaking",
  "generate_discussion": "Generate Discussion",
  "generating_discussion": "Generating Discussion",
  "discuss_prompt_language": "Choose a language for the discussion prompt",
  "level": "Level",
  "grouped_discussion": "Grouped Discussion",
  "not_present": "Was not present for the discussion",
  "view_recording": "View Recording",
  "generate_feedback": "Generate Feedback",
  "generate_feedback_for_all": "Generate Feedback for All",
  "performance_rating": "Performance Rating",
  "feedback_submitted": "Feedback Submitted",
  "group_not_submitted": "Group has not submitted a recording yet",
  "this_classroom_is_archived": "This classroom is archived",
  "submission_graded": "Submission Graded",
  "view_submission": "View Submission",
  "show_more": "Show more",
  "show_less": "Show less",
  "submit_feedback_confirmation": "Have you reviewed all generated feedback and are you ready to submit it to students?",
  "submit_feedback_scroll": "Review all feedback before submitting it to students",
  "ai_draft_not_edited": "AI draft, not edited",
  "edited_by_you": "Edited by you",
  "approved": "Approved",
  "approve": "Approve",
  "undo": "Undo",
  "x_of_n": "{{x}} of {{n}}",
  "ai_drafts_reviewed": "AI drafts reviewed",
  "approve_ai_drafts_to_submit_one": "Approve {{count}} AI draft to submit",
  "approve_ai_drafts_to_submit_other": "Approve {{count}} AI drafts to submit",
  "ai_suggested": "AI-suggested",
  "ai_suggested_tooltip": "Your teacher used AI to draft this feedback and sent it to you.",
  "course_topic": "Course Topic",
  "discussion_topic_helper": "Select a relevant topic to help generate the discussion.",
  "no_groups_created_yet": "No groups created yet",
  "select_students_from_the_list": "Select students from the list on the left to create a group",
  "drop_members_here": "Drop students here to create a group",
  "drag_a_student_here": "Drag a student here to create a group",
  "new_group": "New Group",
  "cannot_edit_discussion": "Cannot edit discussion with existing submissions",
  "generating_feedback": "Generating Feedback",
  "conversations_graded_success": "Feedback Generated",
  "below_level": "Below Level",
  "at_level": "At Level",
  "above_level": "Above Level",
  "ai_performance_assessment": "AI Performance Assessment",
  "performance_chip_tooltip": "Indicates how a student’s performance compares to the expected proficiency range, based on AI analysis.",
  "performance_chip_note": "Visible only to teachers and intended to support instructional review.",
  "you_are_human": "Si eres humano, deja este campo en blanco",
  "progress": "progress",
  "no_scheduled_assignments": "No Scheduled Assignments",
  "no_past_due_assignments": "No Past Due Assignments",
  "no_past_due_discussions": "No Past Due Discussions",
  "no_archived_discussions": "No Archived Discussions",
  "no_discussions": "No Discussions",
  "no_discussions_description": "Discussions are a great way to engage your students with collaborative conversations. Create discussions to practice speaking, build confidence, and develop communication skills.",
  "meaning": "Meaning",
  "meaning_exercise_desc": "Match definitions to the correct phrase.",
  "meaning-listen-and-speak": "Significado - Escuchar y Hablar",
  "meaning_listen_and_speak_exercise_desc": "Escucha la definición y habla la frase correcta.",
  "meaning-read-and-write": "Significado - Leer y Escribir",
  "select_the_correct_phrase": "Selecciona la frase correcta para esta definición",
  "chinese": "Chino",
  "custom_feedback_placeholder": "Opcional: agrega instrucciones adicionales para enfocar la retroalimentación (p. ej., precisión, complejidad o uso de estructuras objetivo).",
  "generate_feedback_view_the": "Ver la",
  "generate_feedback_rubric_name": "Rúbrica de Crecimiento Analítico",
  "generate_feedback_rubric_desc": "los criterios utilizados en nuestros comentarios de IA.",
  "late_submission": "Entrega Tardía",
  "days_late_one": "{{count}} día de retraso",
  "days_late_other": "{{count}} días de retraso",
  "phrase_definition": "Definición de la frase",
  "phrase_definition_helper_text": "Presiona la tecla Intro para añadir la definición.",
  "generate_definitions": "Generar definiciones",
  "phrases_exercise_desc": "Practice key phrases you'll use in conversations.",
  "phrase_group_name": "Phrase List Name",
  "create_phrase_group": "Create Phrase List",
  "preview_phrases": "Preview Phrases",
  "show_keyboard": "Show Keyboard",
  "hide_exercise": "Hide Exercise",
  "phrase_list": "Phrase List",
  "phrase_lists": "Listas de frases",
  "no_phrase_lists": "Sin listas de frases",
  "all_phrase_lists": "Todas las listas de frases",
  "edit_phrase_list": "Edit Phrase List",
  "hide_phrase_list": "Hide Phrase List",
  "move_phrase_list": "Move Phrase List",
  "remove_phrase_list": "Remove Phrase List",
  "show_exercise": "Show Exercise",
  "hide_keyboard": "Hide Keyboard",
  "editor": "Editor",
  "phrase_list_name": "Phrase List Name",
  "phrase_list_information": "Phrase List Information",
  "build_meaning": "Build Meaning",
  "read_and_write": "Read & Write",
  "meaning_listen_and_speak": "Listen & Speak",
  "hide_phrases_exercise": "Hide Phrases",
  "show_phrases_ecercise": "Show Phrases",
  "generate_defintions_error": "Se produjo un problema al generar las definiciones. Inténtalo de nuevo.",
  "saving_defintions_error": "Se produjo un problema al guardar las definiciones. Inténtalo de nuevo.",
  "auto_generate_definitions": "Generar Definiciones",
  "generating_definitions": "Generando definiciones",
  "definitions": "Definiciones",
  "view_phrase_list": "Ver lista de frases",
  "meaning_exercise_welcome": "Welcome to the Meaning Exercise",
  "meaning_exercise_definition": "Definition",
  "meaning_exercise_definition_desc": "Select the correct word or phrase based on the definition",
  "meaning_exercise_options": "Options",
  "meaning_exercise_options_desc": "Select the correct options for this sentence",
  "meaning_no_definitions": "This phrase list has no definitions",
  "definition": "Definition",
  "review_generated_definitions": "Review Generated Definitions",
  "new_definitions": "New Definition",
  "current_definitions": "Current Definition",
  "play_phrase_list": "Play Phrase List",
  "transfer_phrases": "Copiar a",
  "transfer": "Copiar",
  "create_phrase_list_from_selection": "Crear nueva lista de frases",
  "no_other_phrase_lists": "No hay otras listas de frases",
  "add_row": "Agregar fila",
  "problem_updating": "Hubo un problema al actualizar",
  "exercise_settings": "Configuración de ejercicios",
  "excercise_voice": "Voz del ejercicio",
  "excercise_voice_desc": "Selecciona la voz que se usará en los ejercicios de esta lista de frases.",
  "excercise_visibility": "Visibilidad de ejercicios",
  "keyboard": "Teclado",
  "legacy_voice_tooltip_text": "Older voice technology. May sound less natural.",
  "listen_and_speak_exercise_desc": "Listen to the definition. Say the phrase.",
  "identify_this_phrase": "Identify this phrase",
  "play_phrase": "Play Phrase",
  "listen_and_speak_exercise_welcome": "Getting started with the Listen & Speak Exercise",
  "listen_and_speak_exercise_speak_desc": "Click to listen to how the definition",
  "listen_and_speak_exercise_listen": "Listen to the definition!",
  "listen_and_speak_exercise_voice_input": "Pronounce the phrase that matches the definition",
  "hide_phrase_image": "Hide phrase image",
  "show_phrase_image": "Show phrase image",
  "read_write_exercise_welcome": "Bienvenido al ejercicio de Leer y Escribir",
  "read_write_exercise_definition": "Definición",
  "read_write_exercise_definition_desc": "Lee la definición que se muestra aquí",
  "read_write_exercise_options": "Escribe la frase",
  "read_write_exercise_options_desc": "Escribe la frase correcta en el cuadro de texto",
  "read_the_definition": "Lee la definición",
  "type_the_correct_phrase": "Escribe la frase correcta",
  "read_write": "Leer y Escribir",
  "meaning_read_write": "Significado - Leer y Escribir",
  "meaning_read_write_exercise_desc": "Lee la definición y escribe la frase correcta.",
  "course_description_default": "This is a course to help students speak {{learnLang}} with confidence.",
  "image_builder": "Image Builder",
  "background_color": "Background Color",
  "icon": "Icon",
  "pattern_density": "Pattern Density",
  "use_image": "Use Image",
  "background_colour": "Background Colour",
  "icon_opacity": "Icon Opacity",
  "custom_colour": "Custom Colour",
  "create_chatbot": "Crear chatbot",
  "find_chatbot": "Buscar chatbot",
  "find_chatbots": "Buscar chatbots",
  "add_chatbot": "Añadir chatbot",
  "add_chatbots": "Añadir chatbots",
  "template": "Plantilla",
  "chatbot_name": "Nombre del chatbot",
  "create_scenario": "Crear juego de rol",
  "find_scenario": "Buscar juego de rol",
  "find_scenarios": "Buscar juegos de rol",
  "scenario_name": "Nombre del juego de rol",
  "scenarios_added": "Juegos de rol añadidos al tema",
  "chatbots_added": "Chatbots añadidos al tema",
  "add_scenarios": "Añadir juegos de rol",
  "achievements": "Logros",
  "topic_description_default": "This is a topic to help students speak {{learnLang}} with confidence.",
  "selected_topics": "Selected Topics",
  "no_topics_selected": "No topics selected",
  "add_topics": "Add topics",
  "find_topics": "Find topics",
  "find_topic": "Find Topic",
  "no_topics_found": "No topics found",
  "no_library_topics_community_hint": "Encuentra temas creados por otros profesores en la pestaña <1>Comunidad</1>.",
  "chatbot_title": "Título del chatbot",
  "open_ended": "Abierto",
  "open_ended_desc": "Deje que sus alumnos respondan con sus propias palabras.",
  "quiz": "Examen",
  "quiz_desc": "Guía al alumno a través de una serie de preguntas.",
  "picture_quiz": "Prueba de imagen",
  "picture_quiz_desc": "Haz preguntas basadas en imágenes.",
  "emoji_quiz": "Quiz Emoji",
  "emoji_quiz_desc": "Adivina la respuesta basada en los emoticonos.",
  "quiz_style_templates": "Plantillas estilo cuestionario",
  "no_scenarios_found": "No se encontraron juegos de rol",
  "no_chatbots_found": "No se encontraron chatbots",
  "use_voice": "Usar voz",
  "internal_view_provider_marks": "Vista interna · Calificaciones del proveedor visibles",
  "legacy": "Antiguo",
  "scan_to_open_the_classroom": "Escanea para abrir el aula",
  "classroom_link": "Enlace del aula",
  "copy": "Copiar",
  "tell_students_to": "Indica a los estudiantes que:",
  "invite_step_sign_in": "Inicien sesión en su cuenta.",
  "invite_step_scan": "Escaneen el código o abran el aula.",
  "invite_step_tap_join": "Toquen {{button}}.",
  "select_exercise_phrases_intro": "Marca las listas de frases que quieres jugar. Puedes combinar listas de diferentes cursos.",
  "select_exercise_scenarios_intro": "Elige un escenario para jugar en directo con la clase.",
  "source_type_phrase_lists": "Listas de frases",
  "source_type_scenarios": "Escenarios",
  "clear_all": "Borrar todo",
  "n_of_m_lists_selected": "{{n}} de {{m}} listas seleccionadas",
  "n_phrase_lists": "{{count}} listas de frases",
  "n_phrases": "{{count}} frases",
  "has_definitions": "con definiciones",
  "n_scenarios": "{{count}} escenarios",
  "n_messages": "{{count}} mensajes",
  "n_interactions": "{{count}} interacciones",
  "lists_and_phrases_selected": "{{lists}} listas · {{phrases}} frases",
  "no_lists_selected": "Ninguna lista seleccionada",
  "no_scenario_selected": "Ningún escenario seleccionado",
  "scenario_selected": "Escenario seleccionado",
  "number_of_messages": "Número de mensajes",
  "max_phrases_label": "Máx.",
  "max_phrases_all": "Todas las {{count}}",
  "estimated_game_time_hint": "{{questions}} preguntas de {{seconds}} s cada una, más los comentarios entre rondas.",
  "n_minutes": "{{count}} minutos",
  "live_game_title": "{{exercise}} · {{count}} listas de frases",
  "phrases_from": "Frases de",
  "source_card_meta": "{{topic}} · {{count}} frases",
  "n_more": "más",
  "waiting_for_students": "Esperando a que se unan los estudiantes.",
  "how_students_answer": "Cómo responden los estudiantes",
  "answer_keyboard_and_word_bank": "Teclado y banco de palabras",
  "answer_keyboard_and_word_bank_hint": "Los estudiantes escriben, con las fichas de palabras como apoyo.",
  "answer_keyboard_only": "Solo teclado",
  "answer_keyboard_only_hint": "Más difícil — los estudiantes escriben toda la respuesta.",
  "answer_word_bank_only": "Solo banco de palabras",
  "answer_word_bank_only_hint": "Más fácil — los estudiantes tocan las palabras para colocarlas.",
  "time_per_question": "Tiempo por pregunta",
  "all_n_phrases": "Todas las {{count}} frases",
  "includes_one_from_each_list": "Siempre se incluye al menos una frase de cada lista seleccionada.",
  "chatbot": "Chatbot",
  "scenario": "Scenario",
  "conversation": "Conversation",
  "from_course": "From course",
  "from_course_named": "From course: {{title}}",
  "start_topic": "Start topic",
  "start_chat": "Start chat",
  "start_scenario": "Start scenario",
  "n_activities": "{{number}} activities",
  "roleplay_turns": "Roleplay · {{number}} turns",
  "filter_by_type": "Filter by type",
  "view_course_named": "View {{title}}",
  "show": "Show",
  "content_type": "Content type",
  "all_content": "all content",
  "results_summary": "{{number}} results for “{{query}}” · {{types}}",
  "n_results_named": "{{label}}, {{number}} results",
  "view_chatbot": "View chatbot",
  "view_scenario": "View scenario",
  "all_languages": "Todos los idiomas",
  "all_levels": "Todos los niveles",
  "novice": "Principiante",
  "intermediate": "Intermedio",
  "advanced": "Avanzado",
  "popular": "Popular",
  "courses_shared_by_other_teachers": "Cursos compartidos por otros profesores",
  "no_created_courses_match": "Ningún curso creado coincide con estos filtros",
  "no_joined_courses_match": "Ningún curso en el que participas coincide con estos filtros",
  "no_community_courses_match": "Ningún curso coincide con estos filtros",
  "courses_added": "Cursos añadidos",
  "problem_adding_courses": "Ha habido un problema al añadir esos cursos",
  "search_topics_placeholder": "Buscar temas",
  "search_classrooms_placeholder": "Buscar aulas",
  "search_student_name": "Buscar nombre del estudiante",
  "search_sections_and_topics": "Buscar secciones y temas",
  "clear_search": "Borrar búsqueda",
  "x_of_y": "{{shown}} de {{total}}",
  "outline_filter_count": "{{topics}} en {{sections}}",
  "topic_count_one": "{{count}} tema",
  "topic_count_other": "{{count}} temas",
  "section_count_one": "{{count}} sección",
  "section_count_other": "{{count}} secciones",
  "no_sections_or_topics_match": "Ninguna sección o tema coincide",
  "try_different_keyword_or_difficulty": "Prueba con otra palabra clave u otra dificultad.",
  "nothing_matches_keyword_at_difficulty": "Nada coincide con «{{keyword}}» con dificultad {{difficulty}}. Prueba con otra palabra clave u otra dificultad.",
  "session_feedback": "Tus comentarios",
  "session_feedback_preparing": "Preparando tus comentarios…",
  "session_feedback_unavailable": "Tus comentarios no están disponibles en este momento.",
  "suggested_level": "Nivel sugerido",
  "session_report": "Comentarios de la conversación",
  "view_full_report": "Ver comentarios completos",
  "rating_approaching": "En progreso",
  "rating_meets": "Cumple",
  "rating_exceeds": "Supera",
  "area_of_strength": "Fortaleza",
  "area_for_growth": "Área de mejora",
  "rating_not_yet": "Todavía no",
  "session_report_short_interaction": "Interacción",
  "session_report_short_vocabulary": "Vocabulario",
  "session_report_short_function": "Función",
  "session_report_strength": "Fortaleza",
  "session_report_growth": "Mejora",
  "ai_generated_report": "Comentarios generados por IA",
  "ai_generated_report_tooltip": "Generado por IA solo a partir de esta sesión. El nivel sugerido y las valoraciones son estimaciones, no una clasificación definitiva.",
  "session_report_new": "Nuevo",
  "chatbot_mode_name": "Chatbot - {{mode}}",
  "chatbot_message_count": "{{count}} mensajes",
  "chatbot_message_count_one": "{{count}} mensaje",
  "chatbot_message_count_other": "{{count}} mensajes",
  "attempt_count": "{{count}} intentos",
  "attempt_count_one": "{{count}} intento",
  "attempt_count_other": "{{count}} intentos",
  "of_total_correct": "de {{total}} correctas",
  "attempts_to_review": "Intentos para revisar",
  "attempts_not_shown": "{{items, list}}: intentos no mostrados",
  "count_correct": "{{count}} correctos",
  "count_incorrect": "{{count}} incorrectos",
  "count_skipped": "{{count}} omitidos",
  "count_partially_correct": "{{count}} parcialmente correctos",
  "view_all_count": "Ver los {{count}}",
  "view_attempt": "Ver intento",
  "scenario_description_default": "Este es un escenario para ayudar a los estudiantes a hablar {{learnLang}} con confianza."
}
